const nmr13CJcamp = `
##TITLE=SVS-701A3.11.fid
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=SVS-701A3.11.fid
##JCAMP-DX=5.00
##DATA TYPE=NMR SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=Bruker BioSpin GmbH
##OWNER=nmr
##.OBSERVE FREQUENCY=100.62383593053799302
##.OBSERVE NUCLEUS=^13C
##SPECTROMETER/DATA SYSTEM=
##XUNITS=PPM
##YUNITS=ARBITRARY
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=147.58525877714158
##LASTX=-103.37058777795372
##MAXX=147.58525877714158
##MAXY=2894.0
##MINX=-103.37058777795372
##MINY=-14.0
##NPOINTS=65536
##XYDATA= (X++(Y..Y))
65536@A@@bcbbba@@ABAAA@abccba@@@ceedbbbccbba@A@aceeeffecba@@ABBAA@abcdc
65470aabdfecbcefeddgggfddeeffghhffffdbaaadedccccccddc@A@@bbaba@AA@@acd
65405babbba@@@@@@@AA@@aabccbaceeedca@@BA@@abbbcdddb@@ABCCCCBAA@@acbbc
65341caabcdcbbcdeecbccddcbbccdedcba@aa@@@cceffdabcca@@@adecbaa@abaabb
65277adggdbceffdcefedcb@ABCA@@ABAaa@@@@cdeedccccb@@adddcdfghecba@@@ab
65213cb@A@@@@@@@@@@@ACDCBAA@@@@@@@@@aa@@@@aa@acdddccccca@@@@@@A@abbef
65149dccaaaaaabdb@@cfhhfc@@addddefgfdca@A@abbbbcdcddedceedddddefgfeee
65085gfdcfe@@@abcca@@@aaa@@AA@@ACCBBBBBBBA@@@ACB@cfgfc@@@ABBB@ba@@@@b
65021cdfggefhgc@@BCBAAADEDBABDB@aaba@abcegfeeeeefgecccccbcba@@@aa@@@b
64957baabeedfeccbaababcca@@@@@@@@aaadffddddfffggfdcbaaa@@adb@A@@@aaab
64893ccb@@@BCA@cbcddffgffeefgfggfecbdda@@acbbaaa@@@@dfghhfb@@@@bcdddd
64829babdec@@@aaabdfgghfdefdbbacfeehihfdb@@BAcdbbdecabccb@@A@abaaabcc
64765ca@@@@aaa@@@@@acdddbaadgfdba@@cfgffeefghffihhgeb@A@bba@accbaABBB
64701@egggffeddeffdcefecADB@bbaa@abcggfcbb@@ba@@a@@@aa@@a@ADECAABCA@@
64637AAadccbabbccccbaaa@aa@BA@abbb@CDAbdaA@@AAA@abbb@BDAabdgihfdcfghf
64573effeca@@@@aba@@AA@abcdccc@@@@@@A@@@AB@a@ceeeedcbbcccdddcdddcbadh
64509fdcbaba@@dedccdcdffdca@@@@@@AA@@abccfgffgdbcedcbbcefgggfddfa0a1
64448hecbaaceeeffgeb@B@dhiihhfcbbaACBA@BDDD@cca@@addcbccb@ADFEB@bcgg
64385dbbbaabdgebaabcdcaaaab@Aadeeec@accbcffffec@@cdcddbA@ceffd@@a@BA
64322@cefec@@bcdedaA@aa@BA@aaba@AA@bddeeedbabegggigedfghffgeca@@@bbb
64259b@A@bfhiiihecbaaeia1a1a1hfggdaacddabcaab@@@@A@AA@ACCC@@BA@cfdbb
64199ccdda@A@a@bb@@@abcbccaabbba@@abcccddb@BB@@@@@a@@cdffd@B@ba@A@bd
64136dcabdfghfbabdedaBBABCB@cdb@@@bcca@addccdbaa@A@cedbbbddc@@bddeff
64073edccb@@@@@@CDB@@bcbdeedbadfffeeedfghfdbbccccdgihfefgdcbccb@bdef
64010fedeggebbdffeeeffedbaabcdddcbabccbaabdfgghgcbddbbegfdccefgfeed@
63947@aa@@@aabdfdddddcbbcehgcbccdfggedbbdgfdcddb@adddb@aa@bedccbcca@
63884@ABBA@@bdcb@@bbcccbcdcccb@ACDB@cddcbabdffggebcffggfeefegfcccbbb
63821bca@@@efedcdffebabcca@AABB@abccdddddcca@@@@@aa@B@aa@@add@@acgih
63758gfcb@@ABB@acccegha1a1igeedeeda@@@@@@bedcegiiieb@@AAAaba@@bca@@a
63697bba@@accb@@aa@@ababbbaBDAcggf@AadhhggiihgdcffdcefeccbbdcaA@bfge
63634egfddddbbcdfe@DDCB@bbcdedaadd@DFEAceedcbbdfedefggfeedcb@@cedd@@
63571AA@@bbcegghia0a0igebaabbbb@@A@aa@@@BDECA@bdca@baaa@@@@@@@@@@cff
63510defeeeccddfdccca@bfgfdddb@BAA@a@CFED@cca@AA@abddbabbaabbdghhggh
63447fefgdb@a@@cdeca@DDCEFDAba@abcdbbb@@a@@BABCA@A@bcdccc@@cfgihcace
63384gfccba@@@@@@bcaacdcddddccaadiifedcddc@adeeddba@@cdddbAB@eia1idb
63322cdbaab@@@aabbabcb@@aACCAaa@@a@BCDCBCB@bedba@@B@@@aa@@ceeeaacddd
63259ddeecb@@@@@@bccaACCCA@A@@bbabdfgecdeca@@adffgeda@aabba@@@baAB@b
63196aaaaa@@@aa@@ADFCA@@acbbeeca@aceec@AB@@@@A@dda@@acdfgedfffha0ifb
63134cdeffeefdbcdeda@@@@@bdedeha0ihia0ihia0a0hfeehihihhfdccccbacdceh
63075hdbcffecceggghfbbcaAA@@@ACCBBB@aacdcbb@AA@aaa@@acbaaba@ACCBCCBB
63012@@@CEDB@@ceedcc@@A@a@aabbbbefddefgggfeggfeca@@a@@A@bba@@@acbabc
62949effdcddccbaabccehiggfedccb@@@@@aA@abcb@@acbcghgfghffggggeegfedd
62886efebbcddddc@@@@@@@aceecaACCBB@@@@@bffca@aa@@@bcbbcccdb@CEDC@@ae
62823fd@BCCC@@AA@@abbbdfecdfca@adcaba@@A@@@abbdeddcdeca@@accb@adfeee
62760fcbdegihgfedbbccb@BDC@bbbccddeghgffdabddegfeccddeefecb@@@cdcaa@
62697AABA@cbceddfha0ihhgcabegihfdccdca@beecbbbcdedcacgihfffgggdbaabe
62635da@AABBBCBAabcecbba@A@abcddbbbbabda@adcaAA@abbbdcddcba@acdbbdfg
62572iiia0hebaaehifcccba@aba@ABBAA@abcdefecbbcaA@@beeffgghhhhghihfhg
62510fffdcca@AA@@acddega0ihhia0a0ihgd@CB@ba@@@@@@a@@@@@@@AA@begebaab
62450aababehihgdb@AAABCBBBBBAadeca@a@aa@@@bddb@@@aabbaabed@@@abbba@b
62387ca@CA@cffca@@@@bfiigeb@@cegiiigdcefddddb@@@A@a@@a@ADDAadffa@A@b
62324dbaa@@@ddddefecefecbdggecbcdha0a0ihgeecbcaadeha1a2iedffedaA@a@A
62265AAB@bcddcdddcb@AAA@BCB@@@@bbbbbbbefdedb@A@a@@@@@@bcbb@@a@@CDDB@
62202aa@cdccddcbabccbcaa@A@@a@accbbcbddb@beffhhhia0gcdcaccdfhheccdcc
62140baaa@ADEEEB@dfeccdfecdeefeb@@@@A@befdcceiheefccfgigc@A@a@BA@AAC
62077CDGFBac@@bb@AAAACDA@@aaaabdefe@BA@bdfgghiihefhhecacfecba@B@AA@a
62014@@AC@abbccaAAacdffc@AAAA@dffegggggfdeffecbceededeeda@@accbaba@@
61951bccdffb@@@A@bcb@BC@bacdbbccddebaaabcedbbccbdcbcbdffeca@abbaa@ae
61888fdcbbcbbba@ACBadbbcdcaaa@@@@@acfda@bcccdecbccca@@bb@@@aABCDCDFC
61825B@acdbabddegebacec@BAA@@@@@@@aacffeabdeeedcdda@A@@@BC@bccc@@@@A
61762A@aa@@acba@CDEFFDCCC@bccbdggcaa@@@ACBBBCEDDEGFD@bdggdccaabbbbca
61699@@AB@@@aa@ABB@@@@bbcefebbaccbabddaAA@dffeggefdbbc@@@aba@@bedccd
61636dddbcccdbbdfecdedffddcegge@AAAacbabaaa@CB@bba@@aa@@@aaceedeeffd
61573aBCCDB@@@@bddedaaaa@bccdeb@@bcb@@@ABB@aabbbcdb@accaaaacbdhhedee
61510fhhhebcggdcccbacefeb@@acdcccddeeec@A@@ABA@acbaaa@@aa@@@@@AABBA@
61447bdc@@@bcbdecdcaabcca@abb@DFEDDCBBB@@@@@aa@adegebAAacccb@AA@@@@a
61384abcdaadfgffffedbb@@@AABCEC@egfefffdbdffb@Aacdfeca@cgeeghfcbcdfg
61321ecfgcAB@@@adeeeeedfgfdefhhggfeed@ECA@@aceeccedcccddddeffffha1a1
61260ihd@@@a@abdefhigefdbbeeefdbacdfffcaaabddbaaa@BDAbedbbbbdddbb@Aa
61197bccba@@BCC@acdb@@a@BCB@aa@acdbbabdecabddcbbbccccdfd@@a@bdebACCB
61134@bcca@@@@dfedfffffefgghhffededddefddfhgeefd@A@@abbbcdffecaaddbc
61071ccbccb@@beeccccbabcccbbcdcbcccdcb@@@@aa@aacdegffiigfdbbb@@@aaba
61008a@aa@@cfa0a2a3a2ihgfefghia0a0a0igedaAD@baceeddcdefcba@@BB@cga1a2
60953a2a0efiieba@@@dgfdca@abaa@A@aceedb@@@ababa@acb@@@@acdefc@@cddb@
60892BCB@cdfhgeeeghggghhgedffefeddca@@aabcbbcddffcccb@@abcca@@@@bha0
60830hfeb@beggeddddfeefecAA@BCBabaa@@@@@@@@ca@@abccaaa@AAA@@AaddcaAA
60767AA@bcddddddegfeeddccdcbaaabb@@@A@@baabfgfdc@BDBacda@@@@@@AA@bdf
60704iiededbAEFFCABBAAABDEFFCBbdec@@cc@A@abdcccegffghfecbbabbbdddefd
60641cegfcb@ABadbabb@@@A@aabcdedefhiha0a2a1a0a0heega0gfhhgfca@@AB@aa
60584@bccbdia2a3ieddgiihggddffddeggeccccgiia0a1a0heddcbaaacddcAA@@@b
60526ba@@bcbdghhgca@@@@bcbbcffc@@@@ba@@beeefd@A@@@@abaaaabbccddb@BA@
60463@ababbcfgfdddcbdddcc@@@@a@bdeddffgfedb@abbb@@@aa@adfa0igdbddeda
60401@bedcdba@AC@dfccegihhgdaacfggffeeggfebAAAAaedcbccabbddbccba@A@b
60338ehigddeecbcdd@B@baaa@abbcdeecbcc@BDFDA@A@@@@@ABAA@aba@@A@@@bcbc
60275cdfd@@@@bceedefeeeaAA@BC@bcba@@aba@bfeba@@aaaa@@A@dffca@ACCA@ba
60212bdffeddegea@bffgihgfdaBCBBEEDDDFE@a@aaa@@aaaccegecbacfhgggfeeeb
60149@BA@a@AA@cghiifdcba@@abeihgiigfbabca@@@@@AA@@@bddcaabdfffffcbcb
60086@A@A@cdccdcba@BCBab@bbb@AAA@bcb@CD@adggedca@@@beffghgeedecaaaa@
60023@@bbbdddcb@@BBBBA@@@dhgdb@@@aabdcabdcbeia0ebbcdcdeda@@@@@@a@@@c
59961ggffeefhihgfd@CC@aabcefeeffeffcbcbbbAB@bbccdcbdedcbaadbabcdghih
59898hgfefggffffedcdec@@@AB@@@@ab@acb@abbabbcccb@@@bccb@BEC@acec@@ba
59835@@@@a@@@bbcdedca@@@bbabeeb@bcabcbddcbbehecabbaba@A@@@@@accefdbd
59772hhebcc@BCDCA@bcbcedegffgebbcdefeeggfdccb@@accbcfggdb@@@@B@cdcab
59709dd@@acffedegfcb@AA@@ababefdaaaaaa@BDDCDCAABEHA0A0GC@bca@@ADCBA@
59648ccaceecb@bca@A@@@@@@@AB@dffffcccb@AB@@aceca@CBAACFGC@aceefededb
59585@@A@accddb@@@@accefebAAaehhhihecabba@@@adefiihiihhghgdcca@adefe
59522cc@aaBAbccb@@abccdeffdceedddfa0a0a0fcca@@accbcdddeda@beedb@AA@c
59462edccbbbcdeda@@dcccb@A@aa@A@abcddffefghgdbabeggfddedefegiihffecc
59399efdfebcddb@BBaedbdcbcfihecchhfefggfeeghfb@acbcdecbcdccbbbbbcba@
59336@befda@@@cdcbcddcba@@aAA@bdfeddefeb@@dffgecccccba@@BDCCCB@begdb
59273a@BCCB@accabc@ABA@cdca@CDBbdc@@@ceecabddbbcdeeddfhebcca@ABA@a@@
59210@cdba@acefcb@@@@CC@A@abdfeb@@a@abcccdcdfheaacdecaabbabddba@@cee
59147ccddeedba@@@bdcdefghihdcehiigedc@A@adgfedcbbaaacbadfa0a3a3a1ihi
59088igeccdefedefddcceeeec@BA@cfiheeedbabehia0a1a0geeedcdeedddcaAA@@
59028BDECAadgfdcb@@bba@acfhggffdddfghfbaacccabba@BAABDDBBB@bbbcddcab
58965bbbbbdccdcdfdaadgggfge@@@aa@CB@@ABA@@@abdedcba@ABA@@@afihfdcecc
58902edbbcbAB@@aegea@CB@aaabb@aa@@aaabccabeedefcaa@B@@A@@@aaabcegged
58839ha0a0a1ifcbdfgigc@aceeddcceeefda@A@@@abcb@acdefecba@bddddedbbab
58779bbccfhggeaADDBacba@@@bfia1ifcbacb@@@AA@ccc@AAA@cfffeedbb@BDC@@b
58717eha0ighid@@accaABABA@@bcba@@@cfebaaa@aa@ACB@bbbcaBA@aaabefc@AAD
58655FHIFCBAADEDBAA@adbaa@ABA@@@bcfhfb@ACB@acefhebcb@AA@cb@BCBA@abb@
58592@@@@@@bccaa@@cedb@@@@@@@abcfdcccba@@@dfgecbcdffdffedcbceddca@BB
58529A@bdeeedghgggfdaacdffbAB@cghhfccaa@ABBDDFHGC@bb@A@@acbbdcccb@@@
58466@BEEBA@BDDC@ddb@b@DFGHHEACBaa@@ADEAadfeccefggdbabbccccdecaaabcc
58403baa@A@@@AA@bdddddbADC@@@@@@@bcdccefdccbaabacfgedccfgfffd@CC@ceb
58340abbcddddehhebabcddb@@@bdfhhhfecdeffdddeedbbcbcdcaadeca@@cbA@@@B
58277B@@AAacb@@befdccdeefhhgfeeeffedc@@addc@@a@@@dffecaacfgfdcbcdede
58214eeedbcddeeggd@@@@bcdddedbdfggfcaa@@@@cdca@CFGFECCAaa@AED@acb@@B
58151B@bcba@AAABAabdddcbbbcdeefgfdbba@A@@@bfa0a1gc@ABAaa@cefecc@CC@a
58090cca@@@@@acdfeeffeefd@@@@a@@@@AAAA@acgfda@@accdcccaABB@beedbaacd
58027c@@@@A@bcdcb@@acecbadhihgfeeebcdca@AB@ACCAACCBA@@@abcbaacaacdgg
57964gebceeda@@@ACDB@cca@@@@aba@@AA@a@aba@@@cbadgifeghgedcba@@@bca@A
57901CC@@bcdbaaa@ACDCBA@cddc@BCAAAAA@@@ABBAA@@acbaabdgia0a0hdbdeddee
57840ffeca@bdda@a@abbbcebabbaa@abbdccbbcb@CA@@@acba@bdcabcccdddeefhi
57777hfc@@BBaeeccbabddbaba@bdffc@@aaadggeda@@cdddddb@@ACCB@cba@bca@a
57714bcefghhfddccd@CC@caaaabefdegfdccddddcccbccbaa@AACB@cecddb@AA@@@
57651@accbbccccaAA@@begfeedc@BBaba@@@@@@@BB@@@@@@@@bdefc@AAA@@@aaaba
57588ABBAABBB@acdecbceggfdceda@acddcccddda@@@A@acbb@@bccdgggd@A@a@@@
57525@@bbccdcca@ACCA@abaa@@ceghebbceda@@@@bccccddcbcghecb@AA@aacccdf
57462ebaab@@@@@BA@acdcccaBDAAaeecdfgiigdccdca@@cghhhdabcccb@@@@@a@AB
57399@@@@@acdb@A@bcdeefebaa@@bc@@@@AABA@acefhhfddcdecbcdb@A@abccddde
57336cbcdbbbba@@aefdegggfdabceffecdcdedcb@@@@AA@@@ceefgie@AAA@cdcdeh
57273gc@abcedcdddefgfdaefdefghigeb@BCBAAAA@@AACBbdcbcddca@aa@CCCFGEC
57210BAA@acffcaa@AA@acba@ACDAadd@A@cdcbbbbcc@acdccgigeceffghfdda@@ab
57147a@@ceffeccfihfedccccdffbbacddddeca@aaa@@@@bdcbcedcbba@@@a@@@@aa
57084@AA@bcefecaA@cfgfdccffc@@@bddbAB@bddccdfgheddccccb@@bbbdbabdfda
57021@AA@cedbcbaa@@@@A@BECBABDC@@bb@BBAAacddccdeffefebbba@cecbcdbceg
56958ihe@Aac@BCCCB@a@aaaaa@@AA@bfihebbccaABA@@AA@adeedcccdfdbbbdca@@
56895BDCBAA@@@@aaababdgiihia0a0fddeedcccb@@acc@BB@@@abba@abaaabb@@@@
56834@ACECA@abbcba@befffec@AA@@acdba@ADFEEC@cc@@bddbacfgeddbbdc@@B@b
56771ehihfeb@@aa@@bfhgfecbb@@@ba@@@@@@@@@bc@CFCbghfb@@@@aaccb@@dedcc
56708cdfedaAAAB@cdeeddffdcb@@@BBABDDB@@@bffda@@BCCB@@@addbcegfedfhhf
56645ddca@@ACA@bbbcedbba@@A@bdeghfbabaa@acb@@A@bdcdegihfcccbaa@@AA@@
56582@bcaabb@@cddefc@@AA@@ccdggd@@beeddec@@befefhgffc@@aa@A@@bdedbaa
56519@@cfia1gcdca@@@ABBBAaa@abddefeedba@BEGDAaa@BABC@a@@@@@aacdeeeca
56457bdcaaccccccddcdggeb@A@cdecaceedcdefebaabdfgiggfffdbabfhhhghhfeh
56394higedccdca@@@@bfddffdbbehgeehhfffedbaaabbaa@A@bcegffeefhheb@@Aa
56331cdfeb@@a@A@cfia0ia0hgdbcabbcb@A@cecceeedccegfeefdcdcbb@BB@ACBBB
56270Aaccccfifcddceghiiihgb@bedbbaa@A@a@@aaa@CBAA@aa@@@@BCAabaa@@@@a
56207a@@adbABA@aa@becb@A@@@ccdehgda@@@@@@@@@ABBBAbddcca@@AA@cec@@acd
56144fedcbed@@ceeeedddcaaeiihgda@A@a@bbacdghfegda@afhgfggfghggfedefg
56081gfccbaaaccefeebabdfdba@@@a@BB@@@a@@addbdggdcdeeccdeeefdaa@@aacc
56018bbbaabdb@A@a@@a@@a@@aacbbbdeddca@bccccdffcbcdcbbcddfgffd@A@aabc
55955b@aaaacbba@BA@@bcccbbbbccaacga1a1gdb@A@bbcccdeddedca@CCA@@ehhfe
55894efgffffghgggfghebbccaAADDCECCCA@bcbbba@aaaeghgfffcabbACCB@@bdcb
55831@AA@@@@BCBA@@aa@AAaba@@abb@BCA@@@@@@@cdc@@@BABA@ABCC@befffgggfd
55768@@@@BB@bcbbbcddeghgffhhhhffffecbbcb@@@@@BCA@aabddabceeccdcbbcc@
55705BB@@BA@@@abb@A@bfhia0ifcddb@@@@@abcdbccdfigc@@bdb@@AABB@abegecc
55643babdddeda@@cffcacca@@@@@@acdeeec@adecbbbddc@BA@@addbcddbAB@@@@@
55580@acdeccfha0ifddcdefgfdddcb@acdabdccghgeccaABA@@@cghhhdaABB@@bc@
55518BBBBAA@@bdeeecaA@aa@@@cc@@acbbcca@@@@@@b@BBB@bcabcdccdfffeffc@
55456@@@A@abdfga0a0ihhfeb@ABCA@baAAabaaAA@@abccbb@affdb@@@@@bcbcdcb
55396@bgebcda@abba@@@bbabcefedeeb@AA@bddbacedcccbabba@abdddccbaAA@@
55334a@ABABAA@bcddcddbaa@@@@@bccdddba@@AA@@@@@@@@@aca@aabcdcbcdfece
55272geaadghfbabdfggeegfehgc@@@@AA@@@B@dedb@aceia1a2a2a1hedcaaaabcb
55214ccb@ABCC@bddcbcdddeeedcbbeghfdaaba@BEECB@@@@a@@@acbaabedbbbaa@
55152@@@a@AA@cca@@AB@beda@@cd@@@acda@@a@@@a@@bbbcccccbcdcba@@a@acee
55090feccca@@BBCBA@aba@@deecbbdfdca@@@a@BB@a@AA@cddbaabdeghea@cffgh
55028fb@@aabcaa@@@@@@ab@AAAAA@@@bcaAA@BA@@@babdffeeebACBabba@bccccc
54966eeffdca@bcccegebbbcedcaacfd@ACCCEEB@baAB@dfeeffdcbbcddcccdecba
54904AAbdba@@ACDCBBBBBBBA@aa@@@@ccbca@@a@@@@@a@ACDEGFAcfhfda@abdecb
54842dfghigfggdcdcccbaacc@@aba@@@@BAaaBB@@acaA@cggeefeha0igdbcdbace
54781edddedc@@cdeedec@@@@bcccccccdca@acccdcdega0iha1a0gdbaaaaabdfgg
54722edcbbaaa@@AAA@bb@@accddcbcc@@@ADCCDCCDB@@aba@@cghgffgeca@adeeb
54660@A@A@@@@@@abcefffeda@@@bcdc@@bdfeffdbaaa@@@AB@bbbcdcbba@@AA@@@
54598bdba@@@bba@adeffffedccca@a@abaABBBDGGFDDDEEDB@@@@@@@bdcaaa@@AA
54536bbabffca@@a@@@abdfgigfffedeebbcb@@ABAabcba@@accaAB@cfgegigdcef
54474eeggfda@abb@@aacded@A@bddca@@@@@A@abdddeddbaacdeghhfeedb@AA@ba
54412@BFGFB@@@@@ABAAA@@ADDA@aba@@@cdaBEECAADFFEEEEEDDDEGA0A2A1GDEDD
54353CEIA2A3A4A9B5C0C6D6E9G5I9A31A84B82D81F41D31B04A12F8D9C2B0IDDFD
54322@aCCB@@@A@AB@cdccefhha1a0gfdbccccbceeefebb@A@a@@@@@@@@aaabbcfg
54262d@AA@@@AABC@@adecbab@B@a@@a@@@bfggd@A@acdeccbbbAA@@@@@@@@@aa@@
54200@aa@@acbabbbaabbbc@BB@ceedba@@@bffeca@adddegfdedcdffdca@@@@A@@
54138abb@CEEC@cfgecdc@A@@bcfhhdcdcbcc@@@@bbbdc@@@@accbb@ACBaddcdca@
54076aa@bccbcc@AAAAAbefefeb@bcbbcfeccbbbaabbaaa@aba@@eebbeggffeeeed
54014db@@@@@bdeeddha0a3a3a2igdbaba@bccbaa@bddcehha0a0a0gdbaaabbaabc
53959dcbcccdefgfdbbeecbbaaabefghhhgfecbacdcbbcbbcddcca@@@@@@ABCDCA@
53897adhifb@@AAAacaAAA@@ABA@acefedabccccaaefccebabb@B@bbacffeddbbdc
53835cda@aaaaacegggfghhebbbabcaaabcecbfgeb@a@@bdecabcehiihigfdcec@@
53773@deefhhfehiffedb@@@deefdddefdcccb@BCEEABDBAA@@adddcbbbdffedbcf
53711feffha0hecccefeccdbcfhihhfc@DBcfffdb@@bb@AA@ccbcddddca@adfgfff
53650dbcdfa0a0hhebdeedededdbbdeedb@A@@@@AACDCEEC@cefea@@A@aa@aceia2
53591a2a0hebabcefdbaab@@abaABB@@@a@A@@beecdia0hhggdcbbbbbbacdedbdee
53532ddecaaabbcaAAA@cdaaba@@@@@@A@b@@abdccbaACEFC@@AA@@addbdeea@bcc
53470bceedbcegggfddeeeghgfccdc@BCB@aab@@B@aaaa@@bdfdbacffdca@@@bdeg
53408ihgeeeeedcbddedeggffedcdggfb@acefha0a0ifdccddfggedeeddcbaa@BA@
53348abb@@bbb@@bbabcb@@@@a@@addeddecbbccbb@@@cfebcefhfcbbbcfhgffga0
53287a0igeegd@@acbA@@@@@acaa@CB@@@@@@@A@@bcccaba@@@@@deccbabdcdc@@a
53226abaaceaADEEGFAab@A@a@@abegeaacfecbbcdb@@@@ACC@@abcca@@acccdfeb
53164bbcfiia0gdbaa@@BBA@@@abaA@bddehggfdca@@cffeddcADBA@a@A@@@ceeee
53103edcbcfiihgecaa@@BCCAcedbaacccdfggfggffeeeeedb@@accaAB@ceecccbb
53041cdeddbacb@A@baac@@bcca@@@@BDCB@@@bbaa@@@@@a@BC@a@ACDDDCCA@@@be
52979eefgfeecdfeeffffeecaab@BDCAAA@a@@@bccbbcfecbabbbbbaa@aba@AAAB@
52917bcccbcdddeddffd@ABBbeffdb@A@a@@aabcb@AA@@a@@AA@bccccecbb@@AA@c
52855bacceecb@abdb@@@bcbaaacdefffedbbcbbcba@@adha1a1gb@bfeeeeefebBA
52795@@@babefffbBAbeddfhhgeggecccccbdcbcccccbbbba@acb@@@@abdb@@cbab
52733aa@aaadec@ABBC@bcaAAAabbacccc@@@@@A@abfa0a0e@A@a@bccb@@aegffcc
52673b@BAAAA@acedcdbaa@@AA@aacgifbbcca@bdcbbaaa@@@a@a@@@ADDA@@@@@ad
52611fhihgghhha0hedehhdaabdfedccbbbaabcbabccaaccdeddcba@@aabddfedcb
52550cddfggggfdffc@@@AAa@AEGD@AB@@@ABCA@@abbbaABDDEFECCCBBDCBA@AAac
52488babcbbcddeghigdaaccbbeecbabddcaabccbcddfa1a1ihecdb@aabdccbaa@@
52428@BCCDAbdeecbcabfia0hgfdcdefc@@acefdb@BBBAabcbbdeeffea@bfia1ife
52368eghhhgfecbdefda@bdfhgfddfgfbabbabdfgfcba@BEFDA@@a@@ABAacdfgeb@
52306A@@cdcbb@@B@aaca@AABAABCA@@A@bbcdeffeca@@@@bcb@A@bbcbabc@BB@b@
52244BCCA@@@@accffghgfeedcca@@bddcaA@@ACDC@abaAA@ACC@aaa@@@ab@ADEC@
52182cddb@@b@@@bba@cec@AA@aaehgfaBAA@dfggfdbbbaabbbbccded@@@BB@@@bd
52120cBEDBBBBBDCAADFDB@abccfhhgfghfdabcb@AA@@@@AAAA@@bbabcbabddcdff
52058ebcedba@A@a@addceggfeddd@@bb@BAacccdeefc@abb@A@@a@@@@@ABBA@bdc
51996a@@bcccabdeedeggeddbccdebbba@@@@@@@a@@dfgha0hecdga0a1a0a1hfhhf
51939ccdgggha1a3a2igefhfdddcbdefghigdcaabdcaadefggddcaa@C@ccaabccdd
51880dddeeca@@acggd@A@bcbabbaadiieca@AB@bbabdc@A@@@@@@abdecaaccb@@@
51818CB@@@@@@@acdbACED@ba@@@a@AAacddbbfggfcdgggfgfeecba@AA@accdeggh
51756gcbdda@@bcca@A@@AA@@@abeebacda@dgihgfffc@@@@@@@b@BBCB@@adbabcc
51694egifdefeffdceeddddccdb@adffgghhgeddffdcba@dfeggfdceggeccdcbccc
51632a@@@BAbccdeggdaAA@cedcbaaa@@@a@@@@aegecaabdefggfeeefggfedbceca
51570@ACDB@bbceeeda@BEEDCDECA@@@cfdceedeedfgfdcbb@A@@@AAcfeddfecbcb
51508aa@@@@@@@@ab@BCAAABAadddbbceghhgdbc@AA@@@ba@@@aaba@AAA@bdddeb@
51446@aa@@@ab@@@@ABCFFC@dedbabeiifcddddfghgeca@A@bcddccba@@begeb@@a
51384ccccceebAEFDB@a@@@@cfghgbAAAAabbbceggdbacdca@@A@cfgia1a0geec@@
51324a@aegffecdfeddfdbca@@@@@beffedbAB@dfgfecaaa@@AB@@acefedca@@@CD
51262CEEBAADEFECCDEFEDA@@@@acbbccb@@cfia1a2a0gffeec@@@@A@AA@@aba@aa
51203@CCA@@@@ACBBDDCCDEBAA@@acdcb@@AAAA@@aegdccbabb@AAA@@@cdefd@A@@
51141@@AA@AA@aaa@ABA@a@@@bcb@A@@abbabea0a1ifeha1ifc@adhhebabefedddc
51082abaADDAacc@ABBA@ACEEEDCCBBB@A@@bbaaaaca@@BCAcfeeffefgffedbcb@A
51020accccbabba@AAA@@dghgfddddcaabcc@ABCB@egdb@abb@@adb@adeeeedcccf
50958gfcADDB@@ba@a@@@@cdb@bdeecdgihggfedaaaaba@AAA@aBCA@BDDCCBBBBA@
50896acca@@aabbaaba@@@abcccccaacdedc@@BBDB@bba@A@AA@babb@@@@@A@bbcc
50834baABBCBA@@@BAa@ACCBCC@aa@@baADECAAAA@acdedcb@acfhhfcaba@BBbc@a
50772ccccbabdgghihfddb@@@BB@bdcaabccbcdeedbdgfdb@ABCAab@CDC@cfe@BBB
50710BA@a@@AA@@BB@acddcbcedbaa@@CCCCA@@aceffghebabefggecdbbbbbabbcb
50648@ABDEDCCCEDBBA@bcedcd@FHEBBBA@@@abca@@@ccb@AA@@abb@BB@aaa@@@@a
50586@@acddc@AAAAB@a@@@ccdddcba@A@bdd@AA@@@@@@@bcba@addaaa@@bbc@AA@
50524@a@BBA@@@@BDCCC@bcecabbccbcdbbbbcbdcddceffeecbbccb@DFCCCDD@ded
50462a@@BCDCA@A@aa@BDC@acegigdcccccbbbbcbaabcdefeddccdb@@accb@@add@
50400AACBAA@@ab@@abca@@@A@@abeeeeecbceghfbcb@aba@@@bdha0hefifddec@@
50339@@a@A@@aa@BCBAAbgfa@bcb@AAAAC@@@@aba@abegebbdeedcdffega0a0heff
50279efggffigb@@acdb@aaaa@@@aabdffeddbcfedeeb@ABCBBA@@@@@aacbaaceec
50217deeda@@@@@@bccdecbdffdbaacdghihebccba@acdfggedccba@@cc@Bacccdd
50155cdfdcdcded@B@ba@AAA@a@bedfgfdcccb@@@@@@@aabadedddcdddeddccba@b
50093efhgeefga0a0gbBB@abbabefc@@@@Aabbcfdacec@A@@ACC@@@@@aadddfdaea1
50033a3a1hghhhgedfgfedcbbaABBA@BDDDDB@@BCDB@@A@bghfffedddeedcbdeddd
49973cdcbc@@@@A@@ab@CC@bbabcb@@bfgdbadfd@BA@@A@aBCBabbdddddbbcdefhg
49911gfebacaA@cdaBBCC@@@bbcdc@aeeca@AAA@a@@@@AAABBAABCDDCCB@cbbdedc
49849ccddefha0iihgfeaA@degfdbabddb@@adehhfccbbbdcaa@abbdggfecbabddc
49788bdfdbadecba@@adca@@acebABBA@A@dda@@aca@@BBCC@bcccb@@@@@@A@abce
49726feffddddffecabdca@ACBabaceeggecb@CFHFD@cabbaACDCCBBBAa@@AAA@ba
49664ccbccddedba@beffdcccdfgggefgd@AAAABCDDDEEDCBAA@@@@@bdefgfc@@@@
49602aaa@cedcaAA@AA@@aceggea@A@@AA@A@@@CDC@cfeebABBA@@cefdcddfffeee
49540edb@ABBB@@@@@@@bcb@@acbaa@A@ABBA@@@@@@BA@aabb@AB@ab@@aa@AA@@@b
49478ddaacd@BBA@aceecaabbdefeeeeedcccddbb@@aABDEDB@aadd@acda@@ABAAA
49416@abbdgihecggfededcddcaaaaccceffedca@@@AAaaceffcadeb@BB@deccca@
49354aa@a@A@bba@@@bdba@BEEDDDC@ccca@@AB@@@aaa@AA@a@@ABDB@@ACA@aba@A
49292A@bdcbcbadghhdcegfdedddbabfd@@@@@aaaa@ABA@@bdffeeffghgededbaa@
49230@abbbccaabaabceghhgia0a1ifdbabcaAA@@abbcdb@@A@adc@BA@A@ddddb@@
49170@bb@AA@abbbbaa@@@cdbbcdefdccaabbbbcbaaa@AA@a@A@aa@ABB@abddccdd
49108b@@AA@bddbbaAAAA@aa@B@aACBA@@@A@cffdaAB@acced@@A@@bb@@ABA@bbab
49046dfdaadd@@@@bcddcefeeeb@BBA@@@@@@accabacb@@bcegggeccbaceggfc@be
48984fd@@ccbaabcffffgfdb@@@@@cefccdeddbacffcccdbcdb@CEDA@ba@BCDDB@@
48922bccdca@@@@cca@aabbccccegedb@BBA@bbbcefeeddfggdbcccdffc@@bcbaad
48860dccceca@@aba@@a@AA@aaa@A@bca@@@ABCDDDDDCCCDDD@bfgdacfgihffhigd
48798a@bfeb@AEDB@baa@@@abcabbdfeefeb@@BCA@@aehffia1iea@A@@@@@a@CFC@
48737@@adghfddcccccba@ABAABAABBDAbdgfcaabdfhhgfdaABB@abeia0gefeca@@
48676@bcb@@A@@AAacbceeeeefdca@@dd@A@@aa@adec@@addfga0iebbcceecccbcd
48615fia0hecbbaAAABBAaabdgggggfc@@@bffdcba@@bddbbcbabdedbbcbaa@bfii
48554bBAABA@bbccb@A@@AA@cedefefdabdefdbaadecbdgia1a2iecedcceebaabcb
48494acfa1a4a1eaccbaaba@@@@A@ceedccbbb@@@cec@B@bdededbcefia2a1hfgfa
48437@abdeedffdehiggeca@@BCAaceffefhiea@@@@a@@aABBB@AAA@@@@@accbbce
48375eefdcba@A@a@BDDB@@@BB@ba@@@@@@@@adfeedddcbabcb@@aa@@aceddb@a@A
48313@a@@@@@@@abaa@@A@AA@cddbaacdddcabcb@ACA@@@acbbegeefgfffca@aaa@
48251ABEECCEGFBadcaacdcdeedcbcdded@@aaa@adedbbbaabcbAC@bddeefdceiih
48189fegia0hfggeecbbcccbc@Aaedca@bdc@BA@@@@@A@cccca@@@@@ABAbeecdda@
48128@abbccb@@aaca@@aa@BBAAA@@DEDBBAbeb@A@@bdbcdeeddecceecaBEFD@abb
48066aA@dfgedddb@@aca@bbba@@acdfgffecabdaBA@CDA@AAAAAAbdeffcabda@@@
48004acdb@@@@bb@@A@abbbbcfecccdddcddcddb@@@a@befceedb@bdbaa@ACBAabd
47942cba@bdca@@@@abba@@@@@A@bcccca@@BCA@@aa@BDEB@dgfdccdccbba@BBA@@
47880ADDA@AB@bedcaABA@bbbdeeffcba@aa@@@@@bbcefggecccbdghea@@BA@bccd
47818cb@@aaa@@AA@@@@@@@ceeccedba@abaADDB@ccceedbeiigeeddedbbcdefdbb
47756@bdffca@@aba@@@@begfccddfgfffeddccbbbbc@CA@abcedb@AA@beedba@BA
47694@@bdefeddda@AAacdeffecccdfddcdfffghhfeec@@AEFECBCCBBB@@bcbacdd
47632efgha0a0gc@A@defdbccbdffecabdca@@AAAabcdcdbcia2a2a1a1a0iigeefg
47577gda@@@acdbdca@@@acdca@ABBBAbdeeeb@@a@@@ceedaabacca@aba@@@a@@ab
47515@@DB@aabcc@CCB@@@@@cdcabdefda@BBBB@@@@@bdda@bddccaABAABA@@@bfd
47453@AAAaccbbcffeeecbaabdfgfdb@@cfedfd@CDA@@CCB@befcabbcca@@aca@be
47391edcb@ABA@@aadffgfeecbdfgedddeeb@@ABA@@@@@@aba@aceeebADDCCA@B@@
47329@@ACAacba@CCA@@a@aceffdcdcaBCCCDDCBBC@cdddb@aaAA@aa@@badecb@@@
47267a@@addfggedcbdedcbbceggdcbdhgedefedaacfgfffecb@@ABAacdefeeedba
47205bca@@@@A@addcccdeddefghgc@@aegfghfffdbabcbbbb@@@@@@BEFFFFFEDA@
47143b@BAbddcaAFGB@@a@@ba@@@@@@aabb@B@bccb@@@@@ABB@bfigb@acb@@@acea
47081BBA@@@bcb@ACEDAAACCCCDCA@@aceca@A@@acedbabdddddb@Aadfgggedbddc
47019a@@abbbcdfeefdcegfddeffcbbabdedeha0ihhgffecba@bccb@ABAAA@@@@ce
46958efeddfgebaacb@@aa@@CDDC@ba@BCDCAA@accaaaaabbabccaba@bddaaddbAB
46896A@bcccbcffcaabddbabdefhhffeb@ceedddcdcdfdfia0iebbeebabca@@adee
46835dccddb@acbbbddc@@@@bcbbbABABBCCBA@@BB@aaaabba@@AA@@BCCCB@@ccdc
46773@@CDAabbbbcb@@@A@@BBA@@@@@@@aaacbceecbdefghffb@@aa@@@bcb@AABEF
46711C@@abba@CFDAaa@ABBAAA@dccc@@BEECBBB@@@@@AA@@a@@@cccba@@abba@@A
46649EFECA@bbbaa@@abcddc@@@@@@aaaabba@BCCCEEB@@@@@@A@@abcefdcddaAB@
46587ABA@@AB@@@@bdcbccaA@bbdecbddbadc@@@cgigdcdcbbacfffhhgfhigeeddb
46525begggecca@begebabdee@Abcba@@bcdgedaaefdcdefaAAB@@@@@@bfeaABAAB
46463CDDBbec@@A@cdbbba@@@aa@aefdcb@ABA@cdcb@AA@bcaaaefeecbabbadeeca
46401@acdcbbbbabcba@@@aaaceeaBB@ccdfdbabbdfe@@BA@@@@@@@@egfdbabdaAC
46339B@@ABC@dda@@bddba@aba@@AA@cb@B@@A@accbaADCBA@aa@BAabcccba@@@BD
46277B@aa@@@@@@acefeda@@@@@abbbddbaaa@@bcddedbbca@decbaaccded@ADA@b
46215ccddddaACCBCAeefgffeeeeedcbbcca@@@@@abddghfca@A@cddda@a@BB@cec
46153a@@@ACDDB@a@ABCB@@aba@@@bcbccabccccb@@A@aaacdcdggfcc@CCBCB@acc
46091cb@AAab@@bca@AA@BCCA@AB@cb@@bddcaaabbbbbdec@@@@BA@acbbccb@aa@@
46029bdeddca@CDB@@adcbbddcca@@@@abcbccddbbcdedbcdbaba@ADHIHHEBACDCB
45967@@@@aaa@@@@@bdeec@@@@aceec@@@cccdeeeggedaAB@eghggghhgggecbaa@b
45905dddcbcdecabbacddbaaa@A@bdcbababbacb@AAACBAadeedbbcbbABBBAA@baa
45843bca@aba@ABDDCCB@CFFDBBCBCDECBCB@acdefeefhfbbddcba@abcdecbbcca@
45781ACCAacffghgec@ADB@@AB@accbbbb@@@@acbabceea@addccbbca@@@BAb@EHG
45719DAabbbbcdeghfdaa@@@@ab@BC@@aegfca@BDHHDBBB@aa@@@cc@AABBAA@ceee
45657cb@a@ACEFFEDEFCA@@@BB@aba@ABCB@bcdcccbbcdccegfggfccefecdga0a0g
45597edcdfgfa@@accb@@@a@A@BBAAAA@@@@@@@befdddc@BDAaca@@ba@@aa@@BCB@
45535bdfhhhgfdceedbabdca@ADDAbdb@beecbdccdfeccdedddddcaaaba@@@@@@@A
45473@bcdcddfha0ihgeb@@a@BAAafgfda@adb@@@@@Aadcbccdccddgiheccddddec
45412@@@aa@b@@aa@@@@@bddeffdb@a@A@@BA@BAABA@bba@BCEEB@bccfghgghihgf
45350fcccabca@AAadgfdcccba@@A@@aaabaABDIHB@ABAABCCB@a@abcdeeca@acfh
45288iiigeccddffedcccbcbbabdcbbaaa@@@A@@A@acdeeededdfcbbddbaaa@@@aa
45226@CEC@ccbb@@@@A@deega0a0igfffia0iihgeb@abcbbb@AA@@BC@@ABEGCacb@
45167@abb@@bcdeeecbcdcbbcdcbbcdddbbbb@@@abbbdhhfgfb@Aacefdbacgd@@@A
45105@bba@ab@@aabddcceaBCBB@cefgghfddb@@@befca@@abc@BBBCDA@@@@A@@@@
45043@@cc@ABAABDDDB@@@A@a@@ABCCCCBA@A@aaa@BCDCCEFEBABA@@BDEEDB@@CFF
44981EDDCA@@@@@@@@acdccccacccccaAA@ddb@A@@@@@A@acccdeedca@@@@@B@@@A
44919AB@abccdeedba@a@@bb@@acddddeegiia0a1a1geddefefhhdbcccdeeddeebb
44860baAAAAAaccbbcfgggeaab@@@acfgecdebbdcbba@@@beeca@@ab@@@@ab@@bba
44798@BBABEEDBA@AC@aacddb@@abbddb@@@@AB@@aabaACCDBacba@ABA@@@bdaADD
44736A@@A@@@@@@bdeecABABBA@@bdeeebaaaacefggggcbcca@acc@@adfd@@abaAA
44674AB@bdfeddbaaACB@bb@bbcegihfdbbba@acehiihgdbbabdfgfdb@@dd@BCBA@
44612@@AB@@bcbba@AA@@B@bccaABA@@afgffggd@A@bcdda@@cfffcadecceffdabb
44550@BBafgfc@@ACFFCBB@AAA@@@@ACCBDDDDCBBBDECA@a@@@@@abdfcbceec@CB@
44488bccccdeccb@@cedcaCCDC@@AB@abefffhiigda@@@ccec@AA@bcdefeeffda@@
44426AA@@@aadddegffeedccddb@CEFEB@@@BDGGFDFFDBBBBBA@@AEEBCCCA@bb@BB
44364@cdb@@@@@@@@bdffebaaa@@adeeegfdeddca@@@@cefda@aa@ADDBAAB@aabbc
44302aaa@AA@@@@abcdb@@A@bdcbcccba@@@@@@@@@bdeeddeb@@A@cdedcbbga1a1i
44242hfeedceeddcbb@@cdcdbaabdebaa@@@@@ab@@@@AAAA@abbaabaacdcdefgfec
44180@DHIGBacbaaceeedddfeaAA@dfc@@bcdb@BB@bdcddbbbab@abcdegggfdaaac
44118caaaaaaAB@cdcba@a@@@cdcb@@@abccbcb@@BCCBCA@@acccb@@aaacddcehgd
44056b@@@@@aba@@acffdaA@abaBDDCB@BB@cda@abeeeefcaaaabcaabbabdc@@beh
43994hedegda@@BCDDB@abaaaab@bddccdghebdcbbdddda@bdbaabbbacfecaACB@@
43932A@@ddccbcbbba@@accaA@@acbbcccb@BDCA@@@BBBA@aa@@dhgcbbbcca@A@aa
43870@@a@@AA@@bb@@@acdcccaabaaceddcbbba@@@A@@@abbccbAB@@@acdcb@@aac
43808deec@@@@@adedb@@abbbcccc@BA@A@bbbaa@A@@BDDCB@@ceedaBB@bbcca@@a
43746abcca@@@@@a@A@baaa@@@AA@acb@@dedcbba@a@@@abaACC@@@@cdddddca@AC
43684DFGGGFCBBAacdffca@@@@@A@@@BA@ADCABA@bdba@AA@@aba@BCBBA@caBCBAA
43622A@ACBAAAABCEGFCA@@@@AAA@ADGHHEDEDCEGGFEDB@bbba@beghfeefeb@@A@B
43560DFGEBCCDB@ABCA@@ABDFDCFHIA6B2B3B0A4GDFIIFB@@BDDDCBAABCGA0IFEHA2
43504A4A4A5A5A8B0B1B3B5B7B7B8B8B8C1C6C9D3E2F4G4H1H4H5H8I9A13A29A52A84
43474B32B99C99E51H01A237A916B613B894B641B033A307G90E05C46B52A88A45A14
43455I2G8G3F8F6F2E5D5C7C1B6B3B3B3B3B1A8A4A1GGIA0A0A0HEDCBDGIHECCCC@
43415aba@@@@a@CCA@@@@abb@aAHA0A1A1A0HEBAABBAABDDB@@cfededccbbaaa@@a
43357aaaabeffcba@AAAAAABACCCBA@acceec@BA@@@@aceed@@beedbadfc@ABEFEC
43295A@@@@@A@BA@bcabdddc@@ABB@aadddc@@aaaA@debabaAABA@a@@A@@@AAbggd
43233effdcbcdebACBBAAA@@@@ABDFGEB@@@ABBAabcdb@B@bdecaabbbaacca@BFGF
43171C@aaaccccddfffdabb@ABBBB@B@beghfedcddbacedcbacdedbbbccccegfedc
43109dca@Aaffdfhgdba@@ab@aca@aabcca@@@cdbaaa@aa@A@@A@@@abaabbbb@@@@
43047@@bccdfdb@@ACB@@AAbfeefa0igggc@@@@AA@aaaba@acdcbb@AA@a@@@addbA
42986CA@@ac@BB@bdffdcba@@baaacdb@ABA@A@abaaababcb@@ACB@@ACEGA0A1A0H
42927DCDEFHHFEDBAA@@a@A@@BFFDA@BDCAA@ABDEDDEECBBA@aaacaaccddcaab@BD
42865D@a@@BBCDFDCA@@@@bccddc@a@A@cdca@@A@@@@@aba@BB@cfecbaaa@@@@ABC
42803CCAAA@cddaaaacbabcegecddcdebdia0gdcdcbcbacdcbaa@@adfffca@@@@A@
42742ab@A@abeffgghgdabcb@CC@deffddccdbbdc@AABAAC@cdbbdedfhfdba@ABAa
42680bbc@A@ACCD@baa@CCA@acc@@@bccbcc@@A@abdffd@BAABDC@bbccdc@CCBBAa
42618ccba@@cec@@@bccc@BA@abbabfgfhgfghfdbcdffeeca@@@@a@@aa@BBA@@ACA
42556cdaABA@bcca@@BAaccdc@AA@@@bcedbadfeaA@@@@ACBaca@ABCA@@@@@@abbb
42494dbbceeccbbbb@@beecacba@@AADGGGFC@bbbdhgedba@@bb@@bfgeaAA@@aa@A
42432Aadcb@AABDEC@bba@@@abbaa@A@cca@accb@CCBCCA@@CFEDCCCA@@@bdcbege
42370a@A@@@cdcb@BA@@@@@@@BDAac@@A@bb@@BDDFGFDCEGGGA0A2A3A4A5A6A7B1B6
42316B9C2C6D1D5E2F0F8H0A00A23A52A84B15B40B50B45B26A97A64A31A04H3F6E3
42291D3C6C1B4B0A6A7A8A6A2HFEDBABDDECA@AA@bedaacfgecceecbb@@baabcccc
42239aacddddcbbaabaa@accbBCBA@aa@@@@@baAC@ceeddbcaBCACBa@@@@@BAa@@@
42177@@@@@a@BDAbcbb@BEHHEBABB@@@aabdfeda@ab@cffdcbcddcb@@ABDDCBBA@@
42115@abbcb@BDCC@acdggfcddb@cbaaa@aba@@AA@@CEEBBBABDDBBBA@bcdfhia0a0
42054igedcbca@@@@@aadhihfeddda@ceffeb@DCA@@aa@@abbbaaacc@@cc@A@@@B@
41992@@ADCB@cceeaABBA@@AA@cddeca@@acccddeggfdaaaaba@aabdedffddecaab
41930bcddddcdeefghhgfdehiiihgfcbdffeccehfa@@@bbaaaa@accb@BBaaacedbc
41868ddba@bdefeccbcc@@addcbab@@@ABAbb@@dha1a1a0a0gccddcfebbcdgfefgh
41810iheedcdcbbcddcded@AA@a@CDAaba@@baaccaaba@bddb@abaabbcceeccdedc
41748ceefgiihfggcba@@AB@ACCA@@BB@adghhfc@@abaABA@@abcdca@@ba@@CCBAa
41686dc@CA@@bfffgeb@@@abeeeedccaABA@bb@ABAadfgfeeedddec@@@@a@@@@AA@
41624aa@@ehgfb@@CDC@bbccffdd@BA@@@abbbcdeeed@@a@@aba@@adeeddccbcca@
41562@baabcba@@@A@cdddcccaAEDA@@bfgecabb@@@aa@BCA@@@@BDDBBAAABC@@@a
41500bcfd@abehhfbaa@ACCA@aa@@@@@@@@AAAAA@aabbdedbbbbegfca@aaceedcba
41438bcccda@@@@@@@aaABA@@adeefeedbA@@BBA@ACDDB@@@abaa@@@A@@@a@@acba
41376a@ACDCDEDCAAA@ADDB@BB@cbacedaacffdbeigccddbabcdb@@BCAabca@@dea
41314@abcbaceffhihfdcfhgc@@befdaCEDC@edbcb@AAA@bedccdeecaAA@A@@CGHE
41252BBadffgieccbbddcbcdd@DFDA@@@@ABCCDDDDDFCBEDB@bcaccb@a@ABCCB@a@
41190CEGFDA@@ADCBA@bb@@BDIA1A3A0GDBA@ABBA@@@@AA@@a@@@@aa@aaaABB@@cg
41131gea@A@@ACFGGGHA1A3A4A4A2A2A2A4A9B4B9C4D2E9H3A19A75B81D59F28F50
41096E06C03A65I7F2D3C0B3A7A3A2A0FBA@@bb@@ABDDBCDEGGFB@@acdccb@Abfed
41049ccddeeba@@aa@BCCCBBCDCCBCEEEEFEA@abegebABB@cdcb@AACEDBBCCDEC@a
40987bcb@@AA@@BD@bcbcdffb@@@@@@bddca@ABAB@cddbbdda@@@adffbbbaaA@abc
40925egfbabb@@bcddehhda@@@bdcbcdc@@aba@BA@cb@@@@@bbcabeeda@acbcca@A
40863ADFEDB@bceeefgfedaadfedcbbceefeddaBCA@@@@bb@@abba@AACEFECAA@aa
40801bcdeghgfebabcdeeddha1a1a1iea@bbba@@CEEDCB@a@bb@@acaBEEC@bdeghf
40742eaBABCCBABDGD@@AABCDEDDC@aaBCCA@@A@cb@@@AA@aabdhigfefffeccegeb
40680abdbAA@bccccbddaa@@aa@@@@@@addb@@@bec@cfdddbbcc@@bdeecccaa@AB@
40618aBCAacccbba@AAaffda@aeeec@DDBacbccbb@A@@@@@a@@abcabdc@@baa@EGG
40556DAAA@ccddccbaabbcec@ADEDCCB@aaabb@AB@bddc@DEGIA0HEA@@@@a@A@dgf
40495eb@aa@abaACBA@bcb@@ccbbba@@a@@bc@@bcehhhgedb@AA@ba@@@@@ba@@@aa
40433a@@@aacfeecbbddeefgggdb@bda@BDC@a@CCCAacdfgdbb@add@aca@aa@AAAa
40371b@DD@bddcddba@@@@@@AAacbacdddcdfdbdgighhedbccaAA@@@A@@@baA@cef
40309d@BDCACDA@@adedhigeeccba@CDB@@@AA@bca@@B@acccaa@@a@CBCB@a@@@BA
40247@ba@BDDCABB@abddba@@@@babdeghfdbb@@bdecba@@aegeeddddddcca@@acd
40185dcba@@AA@@@@acbabcdecba@@@@BB@ab@@@@@BBDEDCB@@CDBDECA@bbAFEB@a
40123ccbaAA@ADFDA@@@aaba@@b@AA@@A@abcddca@BBAAB@@BCED@cfedcb@@cefb@
40061@bcedccdeddbcfgecaceffeehigcaacccdccaCEBAA@@ACBaa@@@aa@@@BAabb
39999@@@@abeefgfaA@@a@adfdb@AA@@a@@BDEC@adghgeb@abcbbc@@bbbdeeedcdd
39937ffdccdehgc@@@@@@acb@@dea@aa@adeebaaaACBaffdaaabccca@@bca@dfecc
39875dddca@@beihgfccccdefghgbAAacbcaaa@BA@addeigc@BBA@acdb@AA@a@A@@
39813bca@@B@a@@accbdia0iggggfghfffeddddc@@@AA@@AB@efdcdcdca@@aaa@@@
39752@AAAA@aaacb@BAabaabab@aceeec@AA@@@A@@@@@@aaaa@@@@ba@@ddec@BDGI
39690GECAaddc@BBBA@@@@aa@@A@aabefeeeffca@@BCCDCDFHHECCB@dfhfdca@beg
39628gc@A@@@@@@@@ABBCCCBCCCB@aba@bddb@ABAcffdaadfgfddcb@@@aa@bcbaAB
39566@dedaBEDA@a@a@AAAA@bdc@@@aabccdecbbddccdeeefdb@@aaa@AAAA@@ACB@
39504@@@@@@@a@A@beda@A@@@@CDCB@@A@abcb@bbacffeghfdca@B@b@@@A@@abaaa
39442abcedaaa@AB@@AA@aaba@@cb@@@bdcbcb@ACDAcfeccdca@@a@@abcc@A@accd
39380d@Aa@BB@bbbba@@acedcbca@@@aba@@a@AA@bca@ab@@@abc@DEECAa@acaabd
39318ghgdaBCA@@@@@BDEGHHGHA2A5A6A6A4A1A1IHHECDCBCCEFEDEFHA0HGIIHEEE
39264EEGHIHGGGIA1A3A5A7A8A6A5A5A4A6B2B6B9C0C4C8D4E0F2G2H3I3A07A30A64
39229B12B81C76E27G66A167A616A696A324H87F63E59E08D76D38C94C61C17B30A47
39209A00G3E9D8C8C0B6B1A9A8A7A4A4A4A6A5A4A1IIA0HEDDEECCBDFEA@@ADFFDA
39167AAaba@@AA@a@CCCBEIA2A2IFEFEDFIIHFDAaba@@@BC@dffaACDDDB@ba@acee
39107ed@BCCDC@bdccaAA@A@bdgfdb@aaAA@@aba@AA@aa@@@@A@cedb@@aa@@BCAab
39045bccaacedcb@AABAacehiihhigeefdbaa@@@ADEDDEBbcabddccbbbbdfffea@a
38983debAAADDCEEB@ba@@a@CCCDFECA@a@BB@@ACCBAABB@@baBDC@a@@@@acb@@a@
38921@ABBCCBAABCCB@ceeca@bddccbcc@DGCAaa@@aacc@aa@AEHEAacefb@@@acba
38859aba@@AABDEFEC@@CEECA@cefgggfcceffcbdeda@bcbbdb@ACCB@abcccbegfc
38797caA@bcbbbaacdddddeefgfb@DEDCB@@BCBDFDCCA@AA@Aacbbdeeededcddbab
38735cb@@@CBacbba@ABBCA@acddccca@@@@bcefeeddghhgfdcabcdca@aa@A@@bdf
38673efhggffeaabdded@AABCBABDCBBBCDCBABB@cdfebbeffcaabcaBC@a@cdaB@c
38611eddcbbceghfdb@ADA0A3A1GC@@@@@acefea@bddefbAA@cb@@cddb@@ceeeffc
38552bcb@aa@@bddb@BA@@acfa0ieccb@@aacfggedccccbaaacdd@CCBABCCAab@CB
38491@aabcbbaaabbbb@@AA@@AAA@baaa@BB@@@a@BC@aaba@BCEDBA@@A@cfeaAAA@
38429@@AAACEIA0A0A0HFEDEFIA0HFCBDFEEFFDCDFIA1A0IHGDEIA0IFFIIHGECFA1
38375A7A8A9A9B0A9B1B3B5B7C3C8D7E7F8H1I7A17A40A71B15B82C93E70H59A322
38349A750A574I89E68C43B22A53A14H7G3F2E2D4C9C1B4A8A6A4A2A0GDB@@@@@@A
38318A@a@aaaccca@BBA@cedcbabb@@@@ab@A@bdea@bdaAEIA2A1HGHA0A2A1HD@dd
38261ca@@BDCDEEB@bbaABA@CC@@@@@aa@@aabaAB@ABBA@ABCBaccccaBCA@@@b@@@
38199@a@AEFCA@@AAAAAA@CFEDDBA@@@@@aceedba@BBAA@dgiihec@ACEFFCaega0a0
38138hecc@@AB@@bba@@@BCCCCBBB@cdc@Aaddfedcb@AABBBB@a@bcedcb@ACCB@@A
38076ACC@aaccbccbbcbcb@@ACED@ceeca@@@befedcbbabb@@@@BA@@CGFGHA2A2GB
38016aa@@BCBBA@@@@@@abbaba@aaabcfhiihd@@BC@bcefgeb@@abccbbda@abccba
37954@aaa@bddddefddcaACAaaABBCCCB@@@@aa@BA@abaaa@cca@@@@@@BBB@AA@ac
37892c@@@a@@@AACDCAbb@abbbdfggfffbACBAAaedbbccbbb@AA@BEDB@ceeb@CCCD
37830CCDCA@@@@bccccba@CECA@BBCCB@bbba@@@bcdaDGEBADFEEDCCECABCDDB@AC
37768A@A@BFHHIA2A8B3B6B4A9A4A2A0HFEFFGGGEFA1A3A1IFDCBA@DFECA@ACCADG
37718IA0A0HA2A7A8A8B1B4B6B9C4C8D3E0F3H0I6A15A45A89B57C65E55I07A452A807
37690A541I75E59C38B22A59A21I7G9F5E1D2C6C1B6B2A7A4A4A3A3A2A1A0A1A2A0
37663A0IFEEEB@@@@@BCC@@CCCDCEEDCCB@@abba@A@@ABABBAA@@@AABEA1A6A7A3I
37606DAbdcbaabdfd@@a@BBAAABBA@@@@ABBAab@A@@AA@ac@A@@@ABEDBAA@@@BA@B
37544B@baAABEFDBCAa@@@ACCA@@cfgdb@BCBAA@a@BBAABB@bdcegfccca@@bbaaa@
37482Aaa@aabcbaa@AABA@A@bccbbbdffeddcba@@abbb@ABAaccbbbaa@A@@@bcaa@
37420@cddddeedcba@ACFC@@AA@@aeeaCECCDEC@@@AA@aa@CDDDEEDDAbddecaabcb
37358@aa@BBDEDA@@@bccbbaAAACB@@@bbb@BA@@ABBACB@@ABCDA@@@A@@@A@@@bcd
37296efeeeeccdfgia1a0ge@B@@@@@ACCCAabb@@@@aaBCAaefb@acecbb@@@@@@bbd
37236effedcdddca@BCCCB@babb@@BCA@bdeddc@@@dffc@aca@@a@BDCacb@@a@A@A
37174CC@babaaaabc@BA@@ACCCCAab@ABBBBCAbcbb@ab@ABCDEFEBBBAABCC@aACCB
37112@aa@A@@bccba@@dfdcca@a@@ac@@@@@@@@@aAC@@ab@@@@CEDAaaACCABBaba@
37050bcbbcdfghgefggeca@@BBacceda@@@@cddb@@@bccccefgfccdedb@@aceec@A
36988@@abbba@@BBBBBA@@@@aacccca@@abddbaa@adedb@acddb@DGGC@abb@accac
36926cc@BA@@ABABDCAAA@a@BCB@@a@@@aaacghgfd@CC@a@ACCA@@@@@@@@@A@@@aa
36864dfgecbdeggffedefeb@AAA@a@@@cddfgeb@CEFDA@@ababaaaBB@@@AA@@BB@b
36802decceggdbba@addaCCABBB@ccdegeb@CDEC@a@@a@ABAA@bb@BBCEEGGFDB@@@
36740accca@@aab@BA@@@AABDCBDDAaaaacfecdc@CCBCD@aaacddefdbbddeeccdb@
36678@BCEHA0HGDDCCA@ABafd@DGIHEBAA@@aba@@@@@@BEEGIIHHHGFGGFDBCCAaa@
36617DHHHIIA2A4A6B0B4B9C4C9D5E2F4G8I4A18A55B09B93D35F90A148A673A727
36589A252G37D29B69A82A34A04H5G2F1D8C8C1B4A8A4IGFDCBBDFHIHGECDB@ADFG
36551GFGGIA1A1A0HFDDA@bb@@AA@@@ADCA@@B@beffc@ABABEGGDDEFFEEEFGIA0HF
36493DDB@bddffffedccbabbaabaabcaabbbccaaaabdcbabcc@CBA@AABA@a@@AA@a
36431ca@ABAABCB@@@@@addaacddbca@@A@ab@@aca@@aba@ACCAAadca@BAACC@bcd
36369ddedcb@@acddb@ACCBA@@@AA@@BAABA@a@BCEGFCCA@@BB@@a@@@ADFFDB@aba
36307@@@dffgeddbABA@@@@@@A@@aaabcba@@a@ABFHGGDBA@BC@@aabcdccb@@@@@B
36245CAABA@@@AA@@@AAA@bcccdba@acedcb@@@AACGHGDA@bccb@@@@bcdba@AA@a@
36183@aaabaaaAA@AABCA@@@@a@@@@bbbca@@accba@BCBA@baABCB@ba@@@@a@@ABA
36121@bbbaceedcb@@BDDAAAA@@@@CEDB@@@@@@@@@acc@AA@@A@@AAABB@ddbc@CBB
36059CAabba@@AAA@@@bdcdedcca@@a@@@aa@@@AA@@ab@BCC@effgfggfbAA@@a@AB
35997@A@@@CCBA@@aba@BCAbcb@A@@bdddccceeaACB@@ABBEEDAa@@@@ABDEBaceed
35935@CFFFFDCECBCAaccccccccc@@BBA@@ACDA@@ADEDDEIIHFDBBABCBDFGA0A2A1
35876IA0A2A5A8A8A9B2B4B4B0A9A9A7A4IGFFGIHGGA0A1IGFDCEGFFGA0A1A1A3A6
35835A8A9A9B0B3B6B8C1C6D1D8E4E9F5G7H7I6A02A08A18A36A59A88B24B74C42D33
35808E59G45A015A424B008B597B666B108A453I85F86D94C69B85B26A85A56A33A13
35789I9I0H3G3F2E3D6D1C5C1B9C1C2C2C0B6B0A6A3A2A1A2A3A1HFFHA0A2A2A0HF
35755EDEEDBABDEBBCDFIHEDEGA3A4A4A3A2A2A3A7B1B7B9B7B3A9A6A3A1A0A0FCB
35712A@AABCBCBBB@@aa@@abaaaaabb@@aaaa@acb@@abdfhgd@CBCEGEFDDEDDCCCF
35650GECBBA@@DEDB@@@bcb@A@A@@@@@ceca@aadca@A@bb@@@BB@@ACDB@aa@BAacd
35588edcbcddfeb@@@@bdeca@CB@aaabbb@BEFDAaa@BBCDFFFEEEC@aabb@@a@@@@A
35526B@bbcdcb@@b@CFDA@@@b@@abb@A@@@AABCBBCCBadfhgecc@ABCCAACDCCAabc
35464c@A@abdeffc@A@@ABABDEDDC@dffcaAEFEBACBAA@@@ACCDB@@aabaa@BA@adc
35402beeaA@@@A@AA@@@babefecdfgddedccaccb@@a@@@abbaacfeddcbcdeecaa@@
35340b@BCCA@@@@@A@@@acddffdcca@AAAAA@BCCA@bAB@ccddcacdca@AA@abbbcdb
35278@@ACCA@ba@@ABB@@adeeca@AABCB@@A@@@@AA@ceeda@@@@bfeb@@@ACBAA@ba
35216bcaabbbcdegggfeggecACA@bcba@@bccbaACDEDA@@AA@@@@abaACAabcdcbdc
35154ba@BBA@ADDBBBAAacccedb@BEEBacefecccdedb@@@@@a@AAA@Aaddbababbca
35092AEFEA@@bbddaAB@cfgfffda@dfcceddeccaAAa@DC@bcccba@BCBadecaaADDB
35030@bbbbb@@@@@CDB@AACCA@@BB@a@BDA@acc@@@@@@aabba@@@a@DEEED@deeb@a
34968acdb@@@@@@@a@@A@ABCEEC@cb@@bdddfd@@aaaaabcdeccdeedb@B@a@BBBA@@
34906AABCAAAA@@@a@BCBA@bdccdbACC@aaaa@@bbb@@cc@AAA@@aehiiia0igeb@@@
34845bba@ABCB@a@A@BCDBAA@cdc@CC@a@a@@CCA@@@@@@ababcbcbcdfgifbaabccb
34783cbabba@A@@@@@@@A@BBAAA@beghfddcddcbbabddcdcdfedcaAB@dcbcddbdda
34721@@AABBCBBBBBBAbdffccc@AA@adfedbbdfha0hfggfddc@AA@acdccbdfggebb
34660dfgcAB@abaAB@bcc@abbaadfghhe@BAbeghhffda@@@@@BA@@@aa@@AECaabcd
34598cabdeffeccb@A@@@@bccddffebabfihedbbc@A@@@BDB@ab@AA@@aabbdefecc
34536cbcdbaaA@bddc@@abba@aa@AA@accaaa@ba@@@aa@bdca@bfffeba@@@abbbbb
34474bbbbbbcccbb@AA@aa@@@abdcc@AA@AB@aaccaABABB@b@ABBA@@bbcefebACDD
34412Abcba@cdb@BEGEABAacbba@@@a@@@@@beedbbba@bdedcddefb@@@A@@A@abcb
34350abaa@aba@@@@@cdddcdcccdddca@@@@ACBCCCAACBA@@@@BB@bcdc@@@AB@@@b
34288efgd@A@a@@ABBA@@@@@beeedddb@@@@A@@@BBBB@abbdedb@@@A@@@@aa@@bff
34226db@@@@ABCBBCCAA@@bdcca@@aa@@@@AA@@ccb@@@@@ABCEDA@cca@A@@@ABBA@
34164abaaabcddbaa@AB@@@@@ABB@bc@DDBA@acdb@@@@ABCCC@ba@aa@@ab@CCB@bc
34102a@@@@AAA@@DGFC@acaAAA@bdcca@@@@@@aaaba@@@@ACCCCA@abbcddfedeffd
34040b@@aaa@@AA@@BBA@babdb@ACB@@abb@@@aaA@a@AA@@CAcgeaA@@@@efdcbccc
33978bcgfddedca@bcaACA@@@b@CDB@@cedaBAaehgecaAA@a@@AA@@@@aa@@AA@aab
33916a@abcaacghhgfeeecbba@@bcbcceffeca@@@B@bcdca@@aa@BAAA@@@AA@@@bc
33854@@edb@adb@ced@BA@@BEC@@DFHHECC@bcbcdeec@@cdcccbcdcb@@@a@@@ABB@
33792caacdc@CDCB@BBAABDEDC@bba@a@Aadeedcegfcbbba@@CFFEC@cdddca@@ace
33730eb@DGFDFHHHD@dd@A@bca@@@@abbcffb@@ABBBac@@@@@baCECaddb@BBA@@AD
33668DCB@@A@acbaabbaacdcccbc@CC@acddca@A@bbACAab@A@dgfebaaa@@@@becb
33606@@@@ABA@ccaaaababaaa@AB@bb@@@acb@@@acdbabbbbed@adfebaa@@@@@@bb
33544cefha0hgfb@aabdedcdca@acegfda@@ababaaaab@DC@@CCA@@adeb@@aehiih
33483hfeddcaacc@CA@@aceeb@acbbabdeedcca@A@@AA@cddegeeha0a0gedb@BBCC
33423CCB@@@A@aba@a@@@a@aa@@@@bccb@ACCBAaa@aa@Aabehifb@abefeb@a@@ABB
33361BDDCCDDFGC@babcdcacfhgcaacb@@@CECCBB@@AA@a@adffedddedeedcbbace
33299ca@@@@@@@AABCB@@AA@@ACAA@ceffffffeffedcb@@abaa@@@aaAA@@@AB@acd
33237dda@@@@@a@@abbb@BCBbcacffca@ABCDDCCDBA@@@a@AAACCAaccdca@ccbb@@
33175acba@@aba@@acc@AAAadeebAA@bcb@A@dfd@@@aceeffedccegfdb@@@bdccc@
33113CDAbc@ACEGGDBCCBCCDD@@@@cccdcba@@bb@AABCBAbeecbabb@@aabdeggeb@
33051acffdbbbbcdfdc@ABCDFGECA@aa@@ba@EHHFAcfcdhigbABBBACDB@@AABCEFF
32989DCCB@cdeedeedddehhfca@A@@A@bcb@BBA@@@BCBAadc@@@A@@@@a@abdeegff
32927edfffffccabccdccca@A@deaA@ccb@BA@ddbacb@cfgfeb@@@aa@@abfedfeba
32865accbabdeea@A@a@@BCA@aaCFEDDB@a@CEDA@@BCCCA@@@ACEGFFD@@BDB@@BB@
32803@@ACBA@@a@@@@Aacdda@@AAacefebb@BEHA5A9A1EBA@@A@aabeeec@CEFFEB@
32744@a@@abbb@CAA@aa@ACCBA@AABB@dfdbaba@AA@bdfdb@AAABAa@AAacaABC@dd
32682a@@cggd@BA@a@ABABDCCB@@@@@@cebaaabbcb@@acca@@@@@@bcaadcbbcdca@
32620@A@@@B@cdb@@@@CDCAacedddceghfcb@@@@acdcca@cfdcbcbaefedeia0ihec
32559bbbbacb@@aadca@@@bddb@@ACDEEDCBA@@@@AAAAABA@bbba@C@bcefedddedd
32497@BBABDC@acdbcdcb@BBCDDECBCDDBAA@befda@@AAA@bbbaaa@@bdefeb@aaad
32435fffhhdbb@BAadffeeedcaacb@A@abaaccdcaaa@@ABB@@@@BA@@aefddbababb
32373a@@@@BBA@@@aa@ABBA@@@BCB@aaa@@AA@a@@bccddc@ab@ACDECBBA@@@@baac
32311ca@a@BBAAA@AB@b@BDAabbbcddb@@B@bddbbeeddecbdb@@BFIIHGEDCCBAACA
32249@@abddaa@@@acbaa@abbcc@CDA@@BB@cba@@abaa@@@@aeigeehhecdbca@@cd
32187cb@@@A@abcb@BCCBBDDBAAaefecbaacccefda@cedaaa@@@accaAEFEFEDFHGF
32125DAaceeefgeaBDB@cccccbddbaaabcdefgffdbceeba@@A@ccaaa@@Aceedeffh
32063hhgcADDDCCB@@aabdb@@cedcbbdgfca@@abbaaddbbbb@@aabed@@accaa@@AC
32001EDB@@@AA@@BCAaba@@@Aafia1a0ebbb@BDC@bcb@@@@@@AA@@BDBaa@aa@AABC
31941BAA@@ceebcefdbaaababaAA@aadedbaabeeefggc@bbaaaaaaaBBCC@@@@CBdh
31879ia0a0a0a1a1a0a0a1ifeeeedcbccbbbabccccaabcccaAB@bb@aba@@accddca
31825bcbbb@ABB@accdeecccbaaa@@bddaAAadc@@aabdedcdcabdbba@@a@B@cb@@d
31763ghhigc@DFFEDCEGHHGE@a@AEHHGHHFCA@aced@@bfedb@BCDDDEGECA@aacded
31701cbcccbbbdddgigcbccccdcbbaBDGGDA@@aba@@bcaCFDAa@CCDBacaABAbcbdf
31639ddddcbaabefcabcb@@@@@@@cdefeda@@AAAB@cacgihgdb@@addc@ACCAaacdb
31577baaa@ABDDCECCDFEA@@ADDCDBaccbba@@@@AAAAABCC@ba@BDDCBDECCDCBCDC
31515A@@@@@aaadedb@@AA@bbaABABABA@bccbaa@AAA@@AA@abaa@@aba@@aca@bdf
31453edeiieedbaa@CC@bceedc@CECBBBAB@bccba@cdcb@AA@aa@ACDCC@@@ABA@ba
31391@@bca@bdbACEEEEDBA@aca@ACB@@@@@abbcccba@@@@bbc@BA@ba@@@@@@@@@@
31329bbaaceeeeda@@@@ABCCEFD@@ABB@cefgeedcbceeeedceggffffghhhihdbaac
31267cbeda@@aba@beda@AABBDD@ba@beedcddcccbcdfia0iffeb@A@bdeeeb@bddc
31206a@@@acdddfdAFHFCCA@A@acfgfecbdcaacdcbabbaa@ACAbb@AA@a@abcba@A@
31144cddcbcdcbabcceeca@@AAabdeebccbcec@@ACB@@abeedddeeeb@abaacdda@A
31082CEDCB@@aa@EGD@cabdcbabb@@@dedc@@@@@acddcbcbbeedca@bdcccb@CEECA
31020abba@@abeeeda@@BCAccb@abccba@bdfd@CCCBCCB@abbbcgifaBBABEDBAB@a
30958cfiieb@@@@baAFIGFEBABBCCB@@CEEC@a@AA@@@@@@adc@BCAA@@CDCBAAAAA@
30896AABBA@@adefffhigfhhgha0a0heccabdffc@@ccb@abcfeddcdeefeceedcbb@
30836AAafigcaced@AA@@@@@a@BDDDECAA@bdcbbbcbabcceefccca@bdc@@A@bca@e
30774hedffeedbbbcbcdb@A@@@aACBAA@a@@BDCA@aeggebb@BAA@@AA@@@@aa@@ACB
30712@@@@ab@BA@acdefgdb@@@@AAABCBBA@@@BCA@bcdb@ab@A@cdeda@@AA@abcba
30650cb@@aeffdccaaa@ACDDDDEECBCDB@@@@@A@@ABBCFD@ddaaab@@a@@acdcb@@a
30588b@AABCCCDCA@CCAA@a@ab@a@A@aaaacdddccdcb@@@adgfcb@BB@bbceda@@@@
30526BBBCAabccaADCCDEDCBBBBCCB@aabbbbbb@@@@A@abba@BEDCCCCABCBA@acdf
30464ia0hc@BDDBAAabdccddcbcb@bbcbADC@acb@@@a@aabccbacccb@@cca@@@AA@
30403acdecccbabbba@@@AA@AAabcaBC@defeccb@ABBBA@BBAadfffggffhgebA@AA
30341BDEDB@AA@@@@@@@aa@@@CFDBBBCCB@bdb@@@@@@bcdc@A@cdcca@aba@ABCCCB
30279A@abba@A@cegfeedcaabccccbabaa@@CC@@acbAAcefdcdfffffffdbbb@@ABB
30217AA@@AA@@@adfeba@AABCCB@@CEDBCB@a@BBBA@AAacdeedbbdeeeefffdbc@A@
30155cffggfeddfega1a0ia0ihfffdaacbbbb@befecbbccaacfgbAA@@a@ACDCA@a@
30096ADFHIGECABACDDB@bbbbacc@ACEDC@@bddffeeb@@@BDEFGGGEA@ABCDDB@@ab
30034cc@BA@bdccdaA@@a@ACCBABCC@aa@@@@@@@@@AC@@@@@@@@@@BBCCCC@a@AABC
29972@@@@@a@aaaaa@@@@BB@@@@AA@@@baAABBAabeecdeeddb@AACBAABB@a@A@bbc
29910dcccbccc@CDAabcdefghhgfeddffgeddddba@ABA@bbccdfdbcc@AA@@bdeeeg
29848gfeedeffhhgfdb@@AB@@@aba@BBAaa@BCA@@dfeddcddca@AA@ABB@bccccb@A
29786Aabbbcc@CCABCCCBB@@@@bbbceefedcbbddcbba@@@@acba@BA@@beecbbcdeg
29724geec@@A@bcb@@bb@BDCEGE@deddefgeba@ACEDCDCB@bdccbec@@@bcddeffcc
29662db@BCB@A@@ABAacdcb@B@a@DC@b@DECAbeedcb@A@bcbcc@CCB@beggffec@BD
29600B@ab@@@ABB@bcdcbcaaADCaccddefcaa@@BBA@@abdeeedcddefgfdaAB@babb
29538bb@@a@@@ADDDDDDB@@AAAAA@@cb@A@aa@abaacbaceeddfd@@@AA@aaa@@@@@@
29476aceeccc@@@@A@@@@AAACBBA@@@A@cdcbaab@CDBA@cddcb@ABBA@@@AB@@@@@a
29414@AAAA@aceeca@@ABA@aba@@aa@aeecb@BB@aaa@acb@adec@@ACBA@a@@@@@@@
29352@@CFDBAA@ab@DFEDB@bABBBAaaBBACEEB@@ceeaBC@cca@ACCB@@baAAA@ABA@
29290BDDA@@BB@abcb@beeda@@abaa@@@a@ABDCBA@bdcbaabddba@AABA@@bdeegih
29228fecced@CDA@acca@@bbbbabbbcb@A@baaacccaabb@@@ccaCGGFCA@aa@@A@@A
29166CBA@bcdb@B@a@A@b@ABAAACEECCBAABCCA@ceedegfdfeeffcbbb@@a@BAAAA@
29104bc@@aa@adfia0gffdbbb@aba@ABBBACC@a@@befgeba@@aaaabcddb@Aaddcbb
29043cdddcbdddcaABA@bcb@CEFDBCEC@bb@@@bccdb@acb@ABCDDCA@@@cb@DDBac@
28981CDB@aa@@A@a@@@AAA@ACCBA@@@@ACA@BCB@dffeffca@@cghgfcaaaa@@@cdcb
28919abcefha0hfdeeefeccbbcbaaab@BA@@AB@a@ABDDEDAabbdeda@AA@@CCB@a@B
28858AA@@adeddaBCFFCBCBABCAacdddcca@@@adfeccbabba@ABAA@acdga0idaBBA
28797@@@BCB@ABCCCB@aa@@@bcb@A@dfdbbbcc@@ABAAA@a@DCBDDDDDCCCBA@acdde
28735c@BAaa@@aa@acba@AABDCC@bdedaABAadddb@AA@@ACDDCCBA@@@@acb@@CDCC
28673BCBabbbaABDCA@@@@AA@@@@@@ADDA@@@A@eeaA@a@@BAaefecba@@AABAa@A@@
28611cdb@@bc@CDBadffeeeec@@bb@aaa@@@@acddccdfa0iffeddcddaACB@babbbc
28550eeaabcdccddba@A@@@accaa@@bbbcdb@@@@BCBB@abbbcdegfefeca@AA@bdgi
28488ifcdedb@A@@ceeefffe@BAadeec@ACDEEGCbb@@@BCA@@A@cbbccfea@@bdcef
28426edaaceffgc@@acdccb@CCBA@@@@@@aba@ACDDBaeb@BDDDGHFEEA@aa@BCCBA@
28364@@@@cc@AC@bccb@@acdehfdca@ABA@@aceddc@@@BCDC@@AAaa@BEECB@a@ACE
28302DDCDCBCB@@accdccddbbb@A@ACB@eecaaccbbbddddcbbdecba@@@@aa@A@ABC
28240C@b@BB@@@ABB@bccca@aba@bdbaehgebaa@@@@@AAcghhgghgeeghgedccfiif
28178edbbedaaba@@@@babbaacdddb@@bbb@BCA@@@@@@@@ACDCAACBBAacaACAdghf
28116cabbbabbaabb@@bddddcbbccdddefghgdcba@@@cfeedcccdba@@@ACCBaefed
28054ehgfffc@BAA@bcbcddccddcbbbb@@@ABEGDA@CGGE@ccaabaabdeeca@@@BB@b
27992cc@ABCC@@@AA@bbddaabcabba@@bcccccb@A@bcbbdffedc@acddedba@ABABB
27930BBBBCB@aa@@aa@@bdca@ADEB@@@CC@a@EFCacc@ACBBBCCBAABCBBDDDC@a@@A
27868AAA@AABABEEEFEC@@abdca@cdddedcb@@@@@accc@@@@aacdeffefghihgdbbc
27806ba@BCDFECA@a@BEC@a@CDDEDBBBCDAabcaa@@BDDBBFGC@bdd@CBA@@BDDC@de
27744dcbccdefca@AA@@@@@aab@@BAacbbbbabbbbc@ABA@@adcaaadefhfcaabdgih
27682fddcabcdccecbbdggebbddb@ABA@a@ACCCBbeccbaaa@BDFCBABCB@aa@@a@cf
27620gedec@ADECaaACCBCDB@@@ACDEECaeedb@A@beda@@@aadeedcbcfc@abddbaA
27558@@@@@@adfgdcdc@AA@@@a@@bccc@@@@@@bbbcba@bdcba@ACC@acba@@@BDDC@
27496aa@adeda@BBadfda@@A@aba@@acb@@dedb@BDCCA@bdbabbb@BA@bcddbbeecc
27434ddcACB@@@@@AAacdddbabbaacfhgeggfdccfia0ia1a0ifcbbbdghhgfeeeccb
27375@@acca@@aba@@aabb@B@aaaccccbbcefddcfhgc@@@@AA@@@@BCEECAbcaaa@@
27313cegeb@@@AACFHGDCB@@aaacdcdfdADDCB@@@@@@@BFFCBAABA@@@ccbaacfgec
27251ca@@AAAAB@figcAA@aaaa@AEGEB@@AA@bfcBDBaba@adcaaaaa@AAaa@@@caad
27189fd@acc@ABAbeec@@@@@@@bceecbaa@A@@@@AA@@ba@BDEEC@dec@@BBA@AAacc
27127a@abdeecbaABCBadb@B@aabc@CEFHGDA@b@ABDCA@@ACCCCCA@@@a@@@@A@cfe
27065defecccefedbbbaa@beghfb@@@acdeffdba@abcca@@@@ABA@aaABBDEDBBDED
27003@@ABAAabdcbcdfd@AAA@bccdca@bb@@bcceeeecbbbcefggfeb@@@BBAABCB@b
26941a@A@@@@BA@@DHA1A0HECCB@ababcbaa@BCEDBBB@@beedb@@acccdeffdeed@A
26881@acdb@@acdghhggfdca@DGGHA0GCAab@@babb@aa@@cegebbbefdbbccbdcbbb
26820abbbdcaadhhea@bba@A@bdgggfc@ab@A@bba@AAACBbaBAA@ba@A@ACCB@@BAA
26758CDCBBCBBCCDCAABCBAAAA@@A@cda@@bdcccaa@@adedbaccccccdc@@@@aa@A@
26696abc@BDDDCA@@@bbacegfca@aa@@@BDDA@BAACDCA@cffec@BB@@@@dfeca@@ab
26634a@A@bb@AAacabccddbcdc@CCA@abbdegfdc@@@@ACA@aa@@@@@aa@@cefgfdba
26572dfdaacca@@abaaefffgge@A@@@bccb@AAAAA@BBACDCC@@ACDAbccddbbbbddc
26510eedda@aaa@@@@abcdcdddb@bccdcefddddffha1a2iecaA@cccba@@@acccdde
26450db@@@CDAABA@BB@aaa@@@ACDDCBDEC@aaabbbb@ada0a1ihffdba@ABAac@BDC
26390A@aa@@bbb@@A@abdcdddcbefcb@@bdddddcbcdcaCEB@@bba@EFC@@@abba@AC
26328B@@A@bcbaa@BCB@begggebccbcb@ABBA@cca@@ACEECA@@aa@@aa@A@ADDCDCB
26266DDC@a@Aafgfdb@@accbddeedbbdfecaccbbcefdbbaaabdedcdfgddba@@@@@@
26204CC@@@@@@@@@aabddc@B@ceecaAA@abbba@aa@@acb@@@@BCBA@dgfecABCCCCB
26142@@@A@a@adghigdba@AA@@ACA@@A@a@ABCA@@aceecaaacc@bddbcdeeeeefgge
26080caaa@aa@AA@ba@abdbba@BBBA@aaba@BDDBacdffggdcdfc@@@@a@@@bdegheb
26018bcddddddddddccdeddfda@@@CBCCBB@@@BA@a@@bcdc@@AEDB@bbb@CDGHGEB@
25956@@@@@@@@@@acdeeegfc@A@dfeb@@@@@aaABBB@@@BGIHFECaegfb@@@@@aa@BA
25894abdca@ACA@A@AAA@A@AA@@@@@@@acdeeb@BBBCA@@AB@@ABEHFCA@@@abb@@ab
25832@Aadc@BABCBAA@BBBBBDCABCCBAABCB@aabdeb@@BCDBAABAABCB@aaba@@aef
25770eb@@@DHFDCCCA@@ABDEDCA@aababdd@AA@a@@@A@@A@@@BDCA@bdecaABA@cca
25708aa@abba@adfd@@BBAadddcbccbbcdefe@AEHD@bbaaa@BA@decbbaA@bcbbaAB
25646@aa@@AACCBA@@a@@@@@BCDDAadc@@@@abcba@@@@ab@A@ABCBABA@@ab@B@acb
25584bca@@@@@@CDCBAA@BA@b@@abcbabbbb@BBEFEDDBAAA@@@@ddcbcccdaA@cddd
25522ddeeffc@@bccbb@@@@AAbdbaabddcbbaa@ABA@bedaAB@ba@@@ca@ab@CDA@@a
25460b@A@@@bbaACB@bb@@@bb@@cedaa@@bba@acbabcefb@@@ba@@ABCBCDD@bdb@@
25398bccca@@a@@@acfhgecdeddba@@bdddc@@@AA@@acbaca@@A@AAa@@ababbb@AB
25336B@aa@@cdca@ba@@@@aa@BCB@BDDC@@@bddc@CDCAAaefedbaabccccbfhhifb@
25274AA@cffcaabcfghheddddba@ABDD@a@@@@aba@abddaAAABA@@aa@abcba@@cdc
25212dcADGEB@bba@A@@bccccbabeedb@@@@@EIGAa@@@cffdcb@ABABB@@@@@@A@AD
25150FFFGFCCA@aba@A@cgfca@@@@@ccca@A@accbcfeeec@ADCB@bbabcdeedbcdfg
25088da@@ACBafgdcceeca@@acb@adedbabcaabccdddefggeeggeba@@@B@bc@@ABA
25026@b@CFEDEEDC@cdb@@@@@adfhfdddbbccb@bbbceeba@@@BCCBBAaccddabeccb
24964@AA@@@CA@BDCCEEAaba@@BA@a@@@A@adhgb@ab@A@ABAACBA@@@@@@A@@A@acb
24902AABBABCDB@a@@aaa@a@@@bccdda@@@@@@@ACBBA@ABEB@@@cgha0ifdcba@@bd
24841feba@ACCBCBA@@@@acb@bcdcbabccddaacccdeeca@beeddc@@bcbaabddb@AA
24779@bbcbaaacbcdda@dffbA@@adfdADCBA@@addb@abbbadggedb@AabbccabcaAC
24717A@@@@A@@@@aab@AB@@@@aaab@@AAa@BBA@@@@BBCDAabbbbaaaa@A@@@@BDDDD
24655C@bbcdfeabbaabb@bdca@@CGHEAcfecca@BAAAB@aABBBBAacdffb@@AA@BEC@
24593bcb@BB@@@A@@@@ACECCBDDDDEDCBA@@bdeggecddfia1a0hghihgecddb@ABDD
24533A@abb@@@@@@abcddb@@ACCBA@@@@@@@bccaabcda@@@BABCA@@BDDAaa@@@BBA
24471BAA@A@abccbcdcaADB@@adefecdeggfcabdfecdcbACCB@ca@cbaabb@CDC@bc
24409ca@A@@@@@@bbdfgfghecddccddcbab@@aabba@@baa@@@cefddddddccb@DD@@
24347@ABAab@@bba@AAAACEEDBABCBBBBCECABBBDFFDCDGA2A5A5A6A9B3B3B6C2C5
24295D0D5E1E9G0H6A03A21A45A73B07B45B90C39C86D25D52D69D77D70D36C73B98
24272B27A67A22I0F9E7E0D4C8C2B7B3B1A8A9A8A7A5A4A7A9B0B0A8A7A8B0A9A8A8
24242A4A0HGFFFGFFFEEEFFGA0A5A5A4A4A5A8B1B4B7C1C5C7D1D8E8F8G8H9A01A20
24204A43A68A99B39B88C39C87D30D63D85D94D89D58C96C17B39A77A34A04H1F5E3
24182D5C8C1B7B7B8B9B8B6B2B1A9A7A6A5A2IHIA0A2A3A5A4A2A0HEEGGGECEHIA0
24144A2A3A1A2A3A7B2B5B5B3B4B6B8C2C9D6E0E5F5G4H5I8A12A33A60A91B26B69
24116C19C69D12D45D69D83D79D52D00C28B51A86A35A00G7F1D9D1C6C3C1B9B4A8
24092A6A6A7A8A7A3A1A2A1A0FFGIIEB@a@DFHGHA1A2A1IHIGFFEEDDDDEFECCBBBD
24043EEEGA0IIA0A0IIGEDEFFEFEA@ADDB@b@BC@bb@@@@AAcggdcbccdggda@a@BED
23984A@@@@@@@@CB@abb@BA@bdedecabdgiifcacghcaab@@@@@@@@@@ba@@bdedcb@
23922aaacccbbabcca@AB@@@@acb@abcefdbbabdccdba@bcca@a@@A@defeb@@@@AB
23860BA@AA@@ADDBadefgfda@@@@@@bdfeedaAaecaaceeccefec@@@@@bcb@CFFDDB
23798ACEFFECAABB@@@ACDA@BDDEDCCC@@ABCCDEEECDEDCBBBCBA@ACB@a@AAA@AAA
23736ACAa@CDDCCDDA@@a@A@bedbaACCA@@@AA@@@BCA@abccaACB@@baabca@A@ade
23674dbbdfhhe@DEB@aba@@BB@@@a@@abbbaAEFC@ba@@bffedeeefeeebbbccccaab
23612bdc@@@behigfedccdb@AAA@@ACEFFCDDCEECCCEFFHGEBABBA@a@@@BA@acddd
23550baabbaBCBBCBbgfeffedcbcccdc@@BCCA@cb@AABBA@a@BFEB@CFDAbdcaBC@A
23488CBcfebbbaADAbeggggggffcaabacca@@adddedcdcb@AAab@@@CA@@@a@BCCBC
23426CBABCBCAaaaabdccdb@@@@@@@acecbdfdaBGHGGEDBA@cedca@@@a@AB@aacdb
23364bcdcbaaa@@BCA@@BDCA@@accb@@BCCB@bbAFIA1A0GCABCCB@ba@@cfeb@@BBA
23304BEFC@@@addc@BCCBCBA@bedcddddba@@@@ABAABDDCAADEC@b@ABAABAada@@A
23242CCBBDFD@aaaccb@ACBBCC@ACA@aegeeda@@@cdddfeb@acaADCADEDCCEEEFFD
23180AAA@adcbccb@bfecba@cefecbddaAA@@@a@@@dedaAA@@@@@@cdccba@@@aaba
23118@BAabbb@ACCBA@bba@@@adca@A@@A@abceb@acca@acdca@@BBBDCCCCBAAAA@
23056@ABB@aa@CEFFC@@@adeb@@ba@abbbbaa@@aabbcb@@@BA@@@@dfb@a@@@@aaba
22994AA@ceedbAA@@@@@a@@a@@@@bcaBEFEB@ADCAAAaba@AB@ab@@@@@@AACDCA@@A
22932@@BBCA@CB@ABBab@@@@@@A@a@a@abbccda@@BCB@bdccdeda@aceeedccaaa@@
22870accbdggecacdacecbdddffdbba@AA@bddbcb@@cge@DGFCBafgda@CGA0IIA0H
22810FDCA@a@DDBCDCBA@aa@@cdbaa@aca@ACDDCBBBBAABCCB@bdefd@B@@@@@@a@B
22748CDC@a@A@@@@cffdbcddb@@AAabcaAAAAA@AC@egfedddddddcbcdcbcb@CDB@b
22686bbb@@@a@@@B@acbaadcbaaaacdcddddbccddbaabbaa@ADDBA@CDCAAA@@@@AA
22624BDDCAaabbb@@ABBCCBB@bdeec@AAA@@@CCBAAA@caBAceeedb@@acccbbcca@@
22562@@AEFC@adfeccfiihebbbcdbccba@AAAADCCCAaaaa@BDFFFECCBA@abABafgf
22500feb@@@acdbbcaa@aaaa@AAA@@@AACC@ccccccdda@AA@@@CC@dhihd@DDBA@ab
22438bccdcffc@@@CDCCA@@abddb@A@AABDDAaddcbb@adffdehgeeha0hfggddgfda
22377bcca@@@@a@bddddcba@BCB@baadfeeddddfc@BBA@acca@A@aacddca@aca@BD
22315CBBCBAA@aaaabddeca@@A@aa@aa@@a@A@a@CCDEFE@dfgeccccefedccbbddcb
22253bbabdefdccddbABACCEFB@A@@bdefd@DDCDCBABBA@bbbbaA@abb@aehfdc@A@
22191@@BA@AA@ccaa@bdbabb@@@@CFGFDB@cb@@BB@bcb@@@BEDA@@BDEHFEFGGEA@a
22129bb@@@@BDDB@aaaaceeedaACC@@@aACDCBAA@@@bba@BFGFC@bffaBBB@aa@AA@
22067@aba@bbbbcbadeeeb@@bde@A@@ABB@@A@@@@BBDBcddeeba@BBAadedaAAAA@@
22005bbaa@acefgggeefdbcc@@acc@EGDBCEFFCAA@@@@a@AAA@baa@ABAadeedeefc
21943@CC@@@cddedc@@@b@DECB@ACCA@BBBB@@a@@accba@BBACCBBA@@@bcbbaaa@@
21881ABABBCEFDA@acdb@@@@ABBCDFFFGHHGHHFC@aa@bc@@beffgggfffeba@@@AEG
21819FEC@ADFDA@b@ABA@@ADGHGGEB@aa@@A@BCBBDFFDCB@a@BCCA@aa@AAAA@@Aaa
21757aAEFCBBB@cffdeeeeedcb@@@ACB@bcccfgb@A@bcbb@@@a@@@@@@A@cdfffeee
21695dbbbacba@BCCB@abb@A@aa@@@acdcaa@@CCCAacdedccdfgeedcb@AEGFFEAab
21633eaBBCB@b@@a@BEECDEEECBDEB@@@debaabcccdddeedefefeddc@adeb@baACC
21571BABEDCBA@ADFGD@aabb@B@@bccdcbcefb@CDEDCBCDCBA@abbccbddccceggfe
21509cbcca@bcdcb@@A@aba@@@@@@b@DGFCA@adcbba@CEDCB@abb@@bdbABA@@CEDC
21447BAA@@BDDBBEIHFDCBbeeec@@@@bddc@@@@bceehiia0iedeffedccdca@@@abe
21386feeccdeecba@@@ABB@bddcddca@@bfggfedccaBFFEFDA@@@@cb@@aa@@baACC
21324CCAA@bca@A@@abbaadggca@aa@@@adfcabccbcbbbcc@ABB@@A@a@@@@@@@@bd
21262db@@ABA@@@dddcddcceecaa@BDDA@bbbbbaccbba@@ACCCA@ab@@@@@dcbb@@a
21200ba@aabbcb@CB@adeccddba@@@aacdcceeffhihfddbbdghdcdddcbacefffdbd
21138ege@@abaabcbcefgfca@aa@@@@ABAAABCCDCA@@@@A@@@@aabbbbdeggeccb@@
21076@bdc@CBCDDCA@abaBEEEB@@ABBB@bdecaBDDCA@bbba@CC@bccbb@@@@ABBCDD
21014C@aabb@@@ABAABDEBbdecbaabbcdb@aacdcceffgigdaA@bbcceec@@bbbcdcb
20952babb@DEA@bcdbAAabcffcdecbded@AB@bb@acca@@BDCCCAACAbb@@A@aa@@bb
20890bbaabb@ACECA@A@@@@aa@CDCBA@@@abbcccdcbc@DEEDCA@aba@DDDDB@@@@A@
20828@@AAadda@CEFD@aABCBbca@@@@@@@@aa@@AA@@@@A@ACC@a@A@deeebcefedcd
20766dca@A@acbabbaa@@aabdcccda@AA@a@@@ABB@bbb@ABBA@@cfffccedcccb@CE
20704DAa@AB@cbabcb@@ABBBDC@@@a@@A@@@CEDBA@ACB@aa@@cb@adcABBBBB@@@ba
20642@bcddba@acddbbdefda@cedaABCB@bdb@@BDDBAA@a@@@@BCBAAA@adcaAA@@@
20580bccccbAAA@acccdca@AB@aa@AA@aaab@CA@@ACDBAACCABA@@BEGGDAABAaabc
20518cefeaAB@abdddcbbbbbaAAA@a@aa@@b@B@bc@ADFEEGHGBbddbdfghiihgecdd
20456bcbbabdfdbba@@A@cbbcb@@@CEC@bddfgeaBDCA@@@@bddcccfhgda@AA@@CEE
20394B@@@@@aaaaa@@AA@b@@BCCBA@@@A@aba@AA@@@ACBA@@abb@aabb@ABA@cb@ad
20332dbab@@@@ACDAbbaaacddeedaaa@@AAABDCAACA@AA@@aaabbcdedbab@@@abac
20270ffdcccbbbeha0ighhfca@BA@@@abcb@BCA@AAbcegfdabba@@b@ABBACB@bded
20209cbbaaabba@B@acccddeeedaAA@bdddefgfccbcedcaadca@aabcb@BC@aa@aba
20147@@@aa@bdcbddb@AA@Aabba@A@@@@abbaa@@@@@abcccbb@@cha0a0gdcddcba@
20087BCDD@bdb@bcdc@aabcdedec@cb@AA@aaACAABDC@AC@acdddeffeded@BBA@ab
20025acdbaa@abb@BDBA@BCCBABBBA@a@acca@@@aaa@BBCDGGEDCAadefdccbbcaAC
19963EDB@@@@@@a@BDEFDCB@@DGIHCAA@@a@ABA@@@@@EFFC@@ABABBBBBA@@cddb@@
19901aa@AA@@@AA@ccbbaaabddcefe@BBCGE@cb@CBbedca@@AaaabdeccbabaBCDB@
19839@abaAAA@AA@AA@@@@bccbcffda@@ccbbb@@@ABA@@bccefecccaaaacdcccbba
19777BCB@abaabaACDDCC@@@ACEFFDBACBAB@bcc@BDCAbcb@BB@ba@A@@AABB@@@ab
19715@BEHGEEFFFECDDCBA@@AAEEA@@@a@AABC@@@BBB@A@abbccaABBAAA@BDEFFEC
19653CB@@ACECB@@@aaa@A@AAABA@@BCAaa@AA@@@aba@BCEC@ba@@bbaab@EFEBBAB
19591CB@ADIA0HEA@@aabcba@ADEDDCA@@@A@bbccb@BCDFFDB@Aacdd@ABDCBAACC@
19530@@ABCDCABBB@defdaaabbbceeffgebbcdca@CCBCDCA@@ABaefeddcbabdeedd
19468edbcfeeeghhgc@DCBA@a@@ACDA@@aceggca@@aa@CEFGEDB@@BFEDDDBA@bbcb
19406aabbb@DECBA@cdb@@A@@@BCCCEGEBA@cefdbaabbaAA@aaaaa@@@@ACBA@@@AA
19344AAAabABA@AA@ac@DCA@@@AABDCB@@afgec@AAA@@AABBABDEDA@aba@@@ABCA@
19282aa@A@a@aabaabaBBAAA@@@@cdcbaccb@AAA@@b@@@BBAAB@a@EFC@aa@AABCCA
19220A@bbbcb@BDD@ccbcbaaa@@BCA@@bedba@@AA@@aaaa@@@bba@CEFCadedaABCC
19158DEDEFEDB@ACCCAbbADDDB@aeedaABBA@acb@BCDCCCCBAAA@@A@cdc@CEEDA@@
19096AB@@bddcbbcba@A@ABBBBABB@acb@BA@A@a@@bcb@@@A@aaadeedcaACCAacdc
19034cccdefgdbehfeeefda@@@@CGFDCBabbcfgfegigffdcdddcaabdeffedbbcb@@
18972@ACB@bddcbbdghghhgghfefgd@@@ABA@@@@bccddeha0hfefgghihgec@CD@@@
18911BCA@ABCBB@@@@abbb@@baBBACDBAA@@@@@A@ACCB@cccaaba@acdedddcdedb@
18849@ccaa@@@bbaBAcdda@aaba@aabaa@@@a@a@@@bdbbffcaa@ABA@A@AAadd@A@@
18787A@@@@BDDCBAABAacffd@@@@aACDB@@bbcfa0a1a0gdcc@@abABA@@abbbb@BCB
18728BB@@@bdddefeeedca@bba@@@A@ccaaa@@ADDA@@@a@@ABA@aba@AA@@@dfeecc
18666bba@AAAABDCBABAAA@aa@@dfc@BDDDDCBBAA@abbcbbcbbdfeb@CDDCCAa@ABA
18604@aabca@a@@a@@@@aa@AA@cddccdcabb@A@ab@@@bb@@a@@@@ACCBB@ba@@bdee
18542eefdbbcaBAb@BDDDCBabbccbabdfededbbacc@BBBAacdb@@@AB@@AB@aba@@@
18480@ACB@beggfeffcaa@@@baAA@dffhhfdb@bcddbbfffddaAB@@@aegebba@AAae
18418e@AA@a@@ACA@@A@@@@b@CCA@ACCA@@BCCBBBCCCBCDDDCCCCCCA@bdcbcb@@@b
18356bdfgf@DFDAbdca@@@@dggfeebbbbdcba@ABBBBA@bb@@@befddffd@@aaCECae
18294fffededdcabbAAab@aaabdgfeeca@@aaacddecbcddcbcefeddcba@BCDECAab
18232@@@@AB@aACB@@@@bccb@@BAAAba@AA@abacbACA@BB@AA@A@a@BBaba@@acbbb
18170deeccb@AAAAAAA@baBB@cbabbccccdbaaeia0hec@@@@A@aAB@bccddb@BAA@c
18109ddca@@@@bccb@@a@ABA@accbabcbcb@@CDDBAAB@@@ACAacec@BA@@@@AB@@@A
18047BABDC@ABBCDB@baBEFEDDA@BBA@aaaa@@@@@BDCBCDCBBB@a@aaaAC@@@bb@BB
17985BAbdddegge@@@acddbba@@@abbcec@A@bcccbaA@cccddb@C@cgiiifec@AA@@
17923@bca@abcfihfcbeha0hdb@BCABDEECAaAAadeda@@@@A@acfedccb@BBBAA@@B
17862DDA@a@BB@@ab@@@@@cc@@bddccdddefb@abbdebabba@@accceigddcaa@@@df
17800fhgghfffeb@aaa@@@aa@@@@abdffc@accddcb@@@ABAaefedehgeddedcdec@@
17738@accbADFFDDDCCCAceedcaaccaACCB@aadda@@BEDDC@bedcaAAbcb@@bbb@@@
17676@A@aa@bcaacdcbcbddcacca@@bcdeedddccba@BDFHIFBBA@AABA@@CC@@acbc
17614ddc@BA@ACDDDCDFECCDEFEFECAbdfhhfdcca@AA@BA@@A@abbb@BCDDBAA@AA@
17552@@acc@abbcegfb@@cdccbaa@AAAAA@@@a@BB@@AB@bdbaaaefec@bbcdddba@@
17490ABBCAabbbaa@BDCBA@@AB@bbabc@ABA@abcgfc@BBBDCA@@bcccefghfcba@@@
17428aa@@@@@ABAa@A@AA@aa@adghgd@@@BB@@bb@@A@aaa@@@Abeccddb@ab@cefea
17366ABAABBBBA@@@abdffdcbaaaabdaABDCBCCCA@@CCCAaaabba@abaaabbACFHFC
17304BBAAA@@A@acdcccdda@A@acb@@cccca@bb@aba@@AAbdcbegda@A@@baABAab@
17242@BBababccbb@CCAbeccba@bba@@a@@bdfedb@@aa@@bddbbccbcbbccdeec@@@
17180aabefb@ACBB@bbbcdeeddeefda@@@@@@@BAAAA@@BA@caACB@bc@A@ab@BBBAA
17118@AABBBBAAA@@adebBDDAbbCEBBB@@ACAa@BCAabdedc@Aaabdfda@abb@DCBBa
17056a@@@cdfeaacaa@@ADECBB@@@@AA@AA@A@a@@bdggeaAAA@aa@A@aabbdeedca@
16994cedcda@abdeebaacdbabddcbb@A@@a@AA@@@abceeedbbaa@adffdcbbBGHFDB
16932@@ba@@@ACA@AB@@BA@BDCB@@@@@@@@aa@@A@@@@@@@aabcaa@@@ACDB@ccddc@
16870@BBA@@BCAbcAB@@A@ACAadha0hfda@abbadgid@AA@acbaa@CDEFDBCEDB@A@A
16809BCAABA@bb@@befdcca@@@ACBBCBA@@bcb@@ACDDDDDCA@@@@@a@ACCBBCCAadc
16747a@beedcbbb@@ABA@@bcbaabba@@@@@@@@abbb@@@@aa@dffdcbaab@ADFDBBCB
16685@aa@a@AABCA@a@A@@ABCB@@AEFDadb@CCBDDA@@CFGEDFGFFECAACAA@addbAE
16623DDCaddcaabcb@@aaA@@adb@BB@a@@a@DFC@bbaABA@@abb@@@@BA@CCBA@AAag
16561iiifca@abcddcbaAA@@@@cdb@@BBBCA@aba@aceedba@BABA@BC@baBA@@a@@A
16499ABBBBAA@b@BAA@@A@baB@bceeca@@ABA@@a@@b@AA@baaa@A@aa@@bb@@abcbb
16437ca@@@BCB@ACBAabcdcaAC@cdddbabdeedca@@@@@@abcdedeeecccccegihd@B
16375B@@@@@@ACDCBDEB@AA@@A@ba@AAA@cc@AAABAa@@ABBA@cca@@ABA@@aaabddb
16313a@a@AAA@@BC@aa@AA@@@@@acfhfeccedbabeecb@A@@AA@acehhdbcdcegfd@A
16251@bcb@@ACCCA@aa@BBA@aa@a@aa@@AB@@aaa@@@@@@bcAEFB@aaAAB@abbcbbcb
16189cdcca@abbaababcbbcdb@aba@@@ABBBAACFHGCBAAAabbadiigdbdecdfhigfh
16127gdabcdc@BDEDDEDCA@aa@CEFDB@acedbabdc@BCCFHE@aefffgd@@A@adeeb@@
16065@@a@@abcccaabdeca@cffgecbbccdeb@a@@aADECCBA@A@aa@ABABBAA@ADB@A
16003BB@AAAABA@a@@@@@ACEFCabadgfccda@ababccbbbceeb@BDAbb@@bdcb@@aab
15941@@@a@@@@@BDEDCAA@beddcb@@@@ADDCDFB@@AA@@@b@@bdecaaba@AC@@ABCDB
15879@bddaBDDD@bcdeffhhecefda@aa@CEB@@@bb@@@adcbda@bfedca@@add@A@a@
15817@ACBCBA@ACCDDCAcdddeggda@A@ab@@accb@@affcaabbddba@AAacb@AA@@df
15755ghgdaa@CDCBAAA@AA@A@a@A@aa@@@baABABB@deeea@@@@accdggfdb@@@@BB@
15693@@ABA@AC@cedegfdbccdeghhgffeedcbdfedddcba@@@ABAabaaa@ACA@ABA@B
15631EEB@@@@BC@a@@@@@@@a@BBACB@bcfe@@@@@@BDC@baBDC@bbdeddc@CGDBBDFE
15569EFFCacaACB@@@@@@@@begeaab@@@bcb@CB@ABCCA@BCDDFFDDDB@@acddefc@C
15507CAACDCCB@@CEAbbaacb@@@@acddb@ABB@aa@@adgebaa@@a@@@@@@@A@AB@@@a
15445a@CDDAA@A@@@CDBBC@cdccccbdhidADCAa@CEFEB@@@AEHGD@aabdeb@@ACCA@
15383@@@@@aca@@@a@A@@@abcfifcdfdcdb@@@@BDBBAaabdfggeedcb@@a@A@@@aaa
15321a@@AAA@aba@CCAaaACCA@@AA@@bbb@@aabdddcdca@aa@@cgfeededdeda@@aa
15259a@@@AAaddc@A@cba@@@acbceeeddeebaabaa@CA@bbca@@ABBCDCCBaefeb@@@
15197@BDDB@@ab@@@acefecbbca@@@bbdfffdbcedaa@A@accbabccccdcbb@ABBEFD
15135AAA@@AA@@bb@@@@A@@cegfdbbdfecdcaa@BCB@@aba@@@BA@bbdeca@@aefeed
15073cba@BBAaeeecaaa@aa@CDA@a@BB@aacdeeddeeca@@@abbcefffed@AACDEFII
15011DCDCCCDDA@@@@@adeeeba@@@dedbacddccdedca@a@A@aaaceed@BBBCCA@ACC
14949CA@bggdbbbbcedccbaa@aaa@@BDEFFFDA@@ACDCBA@bbdd@BCCB@@AEECABab@
14887adecacdcbbdeffda@A@aAB@cfggffeefiifa@aaaa@acfhfeedba@CC@b@ABCA
14825@ba@@bccbdb@@A@bccca@abcdefc@acdb@@@a@A@abcbbcbAA@@@befecccddb
14763@@@aba@@@@@bABBCDEEBCCCDCB@bb@@@@@bdedddcccccba@@A@abbcdcb@@AB
14701BCDDCAabbdeeffeccddaCECA@CCCFGFDDB@b@A@a@AA@@B@dd@B@ab@AAAaehg
14639eegggfdeffghigfd@@@@B@b@@@a@AABAacbbcfhgghfecbccc@@@@BCBBDFEDF
14577IHEAAAAA@abdccca@@bcca@@@@@BEFDAadc@AA@@@@BA@@@aa@BB@@@AA@bb@@
14515@a@a@CFHFCCCDDBABB@ccacca@@@BAAA@@dfbBEECBCCCFHD@abdegghifdeeg
14453hgdbacccdfebacdcb@aaaa@AA@@cegeb@ab@CDFECDC@abbaa@acb@B@@abbaa
14391b@ABCAacdcbbba@@@abca@ABBABBABCCEEBaabdgebcbbbaacb@@@aaacgda@@
14329@@@acddaADGD@@@baABCA@@@cbacdddcbba@BB@acefebaaaacgfddeca@@a@@
14267AA@befecb@@aa@CEECA@@AAaaabbcc@@@BCCDDFEDBCDDDDCBCA@bddbaaa@@@
14205ACCA@@BCC@ddbaabbb@AAaefdbbefcbb@@@@Aabbceeca@AA@@bddbADCAaa@@
14143aded@Aacddc@CEFFEC@@cghhedddaBBBDEDB@ba@@@@@acedb@ABA@bcccccbb
14081deghecceedfihb@@acffba@AAabdeeebACEGGFCbefea@aa@@aaacdeb@@A@a@
14019@ACFGFA@bbccdcc@@aa@AAAA@@DFEDBB@a@AABDDDEC@bba@BDFGEECBB@acda
13957ABABA@@ABCDAceb@@aaaccba@adfcbbcddcda@@abaadea@A@@abdddeggfdba
13895aa@bccddedaABAACDDDFGEA@a@@@@acddccdfedfc@@ACCA@@@@cccb@@ba@aa
13833ADDCA@A@cbbddaABBAAA@@bfgdb@AAABA@b@BCB@@ACEDBAaeeeghfdb@BCBCB
13771B@@@@aaAAACB@@ACEDBA@bdec@@@@aaaa@@@acefededa@AAB@cca@@@@bcdca
13709a@ACCAADGHFEEEFEDC@bcb@ADE@@@A@aa@CFA0A0HGC@@AAAacddefggeaAAA@
13649aabaaabddca@a@ADBbdc@@aaabcbbcdfffeb@@ABBCCB@cdeeeegggedeca@@@
13587bddghedb@@@BB@@abdddccdfffffebaa@@@abbcba@@aabbaaa@@@abbaA@a@@
13525@aaaa@@aa@AB@adfdccdddceeb@@@@@@@@ABB@aca@@@ACCCCB@cbbcbadddee
13463ffc@aa@@bcddbba@A@c@@bccbccb@@eedcca@@aa@@abaaa@A@bcddfeccbbcc
13401@@@A@@bcddefed@CFGEC@a@@ACC@acb@@@BB@a@ABEC@@@a@ACDEFFB@BDCCCC
13339DEEEFEED@aaabacca@@@beedcaceeeb@@@@@bbacda@@@bbba@BBB@deca@bde
13277eeeaCDA@aa@@@ACCA@ACBABAA@@ceda@BC@cffdcbb@BCA@@A@@@@BCDEFEDDD
13215DB@@ABDBBCDCCDCCC@@@aabdfffeddddc@DGEAa@A@aa@bc@AA@ababccbaaaa
13153@@@@ABCCBBBA@@@@bca@AAA@bba@CB@@@aaa@aa@BCB@@A@@ABCCB@@bcbcaaa
13091baACDCBAAEFHHECCCFGECCDDB@AA@BCBAACCDFFEEEDB@dc@@@bbaa@AA@bccb
13029a@BCB@aa@DFCBDCCCAbbbcdca@A@@acc@@@CDB@@@ccaADFHGD@cccaaa@@ABA
12967abaaaabbca@@@beffcbdggeec@ACCA@abdbbaADEECDB@@@A@ba@@@@@ababaA
12905@adefecbcddd@A@@@@abb@@@@ADFGGFHIEA@bdb@@@aba@ab@aaACCDEFEB@@A
12843BABB@bga0ihcA@@@@ABB@@befhhebADCB@bbcbBBA@@@@afeaabba@ADFEB@@@
12782ccaAA@@ABDCBBDC@@@@@@@A@@@@cdccfhededca@aca@aa@@@@@@AACCCDEFEB
12720@@aacca@@ACDA@a@a@@aaaa@@abca@a@@@@beeedcccbbb@CCBBCDBbdb@@@AB
12658CCDEECBADEEFEGFDBA@@ABCCEEC@@ACCBFGEA@AA@@BA@@abccaaabcbabb@aa
12596bacfeddfheb@@CFFECA@A@a@@@@@@@@@@AABDC@@AABCC@acdefhgeddedbccc
12534dddbaa@@BBCCDD@ACDDB@@@@@BEDCDCB@aaaa@DFEEEDBCEECA@@AA@@@@@@@@
12472acdedbbaaa@@A@ABA@@acc@AA@ac@@@@@@@@BAabba@bcb@@dhgd@@bdccfggg
12410da@bc@CDB@aa@@ba@AA@@BDDCA@@ABBAAB@aba@CCBDEDCA@@AAAAAABCDFFEC
12348ACEDCCABC@bcdca@@bb@@a@BCAacedccbaceedcaacca@BA@@@@AAA@@@aaab@
12286A@ABCDDCAABA@abcca@@A@@BD@abcbbcb@abb@acca@@@BDCBCCB@@CEGHECCC
12224@@@ABAAA@bfgd@Aadgfdbcc@@@@@@@bcdc@DDBAA@@@CDBA@ac@ABAa@@@@BCD
12162C@cca@BCCCECA@@@@@a@DECABCDEDAabcbb@BCAbddbbdc@@befebcfdabbaa@
12100A@abdccc@A@@bdfeffeeca@ACC@bbbbddccbaa@@@bbceggecccc@AABBB@aab
12038@BC@ABACCA@@ABCAbdedcaccdec@BAaa@@AABA@@@@@bcbcaADC@@ABBB@@@@b
11976eda@B@cb@@adgebaABA@A@bdda@aaaa@bdbbdfefiigc@DDA@aaa@abdffdbbb
11914cccdddc@CB@ADB@@@a@ABBBBBBA@ba@AAABC@deca@AA@@BBAABCEEDA@@@@@@
11852aba@AABCCAceffggffddecbbbaACBABCBDDBA@aa@BCDFGC@bb@ADECCBACHA2
11791A5B0B2A9A3HGFFHA1A1A3A5A4A2A1A1HCac@CCBCCCCCA@@@BCCCA@ADB@@@AA
11742@ceeccddaAAAA@cgfaAAAABDFFEDCB@@CDCCDEBBEGGFBaceb@@@@@ADDDDDA@
11680@@@BDDEFEB@aaabaacdffcba@BABCDDCCAB@@aabbba@@@@ADEEDBAAB@@@aa@
11618BDEEDCA@cdedba@@a@ABABCB@aab@@ccaa@AB@ba@AA@ceeeb@CCABCBAAAB@a
11556aabaAA@@@@abdedcca@@BBBCBacba@acdb@@abcdc@@@BCDGHGECCCCBA@@@AB
11494CBACCCCA@bceeccdeeecba@@@@BBCAA@cefb@@aaabba@aefdba@@acdc@@aac
11432ba@CEDDDDCA@aa@@@cddaBB@@a@BB@bb@aaacb@A@@@@CC@bbAA@aa@@a@@@BD
11370BAA@@BB@@a@@cccedccbabcdbababcedcbbb@@abcedcfc@@@aaaaa@A@@cefe
11308dc@AA@A@@@abdedb@aaa@ABA@@@ab@@@@AFIHFBbb@BBAAB@baAA@@@a@AA@@A
11246Abccccb@CDBBAA@@AA@abba@aa@@@bdedbabdc@AA@A@cfdbb@@acdb@BCB@ba
11184@@@cfgggc@ACFECBCDEB@aaaaa@ADGFEDBB@a@ABCDCCDBab@A@abcffffedbA
11122@@bdec@@@ccb@A@acc@AAA@aaa@AA@@@dfeb@A@bbaa@CD@dhheaabcdc@CBAA
11060BBCB@@@BCBAac@BCDAceaDDCDDA@@aabba@CCB@aaAB@bdggfeda@AAEGEBaa@
10998ACCA@AAABBAAB@bdb@BCACDCBBBCDCDCAAA@@@@@AA@b@ABB@@BDBABA@bccde
10936ehigeba@@@add@CBBBGHECABCCAABDDDBaeffc@@A@abaabbcegfddba@dha0h
10875da@@acdgfb@@@abb@@AABBBEFDBACBacb@@aaba@abddb@aaAA@@@a@BBA@ccc
10813c@BBABDEDBABBBB@@@@@@@abaBDDCAA@@ab@CFFEB@@@bbbcdb@ADEFECBaabb
10751cdcabca@A@a@AB@cba@ADDCA@@ABCBA@a@@@@@cedccca@aab@bddcbbdfhhhg
10689ecceecccbaaaaba@@@@@Aaca@BC@bca@@bccdcaaaa@ACCB@a@@@aaaaaaa@BF
10627GFCaddaCBA@abdeddcccaACDAbcbabb@bddddc@@Aaca@@@@ABCDDB@acdbaa@
10565@aa@@@@ACB@@AA@a@@@@b@CDCBCDDDDDCA@@@AB@@@@@@@ACBABCDECA@aBBAA
10503A@bcdb@@bbAEEDA@aaACA@@@@BBB@cca@@AAABDBACFHA1A0FEDCCAabb@A@AB
10443A@@@CEC@a@BBAA@ba@@bfiihhhfcaaa@AAA@bcb@@bcbaacdeeedfggeddca@@
10381@@@@@AB@ddbba@@BCBAA@bdaDGIFDDB@@@@@@CCBAbdfia0hfc@@@AA@@ABCED
10320CCCDDCAAA@@@@CDBBDDA@a@@aaaccccaBCDC@@@@CBCCB@a@ABBDDBDFFDAADF
10258GGDAAA@aba@@ACBABBA@cfeda@aaba@@ACA@@@@bddbbbcccaACA@a@@@@bcba
10196a@ACCCA@abbb@@@A@@ACCA@@ADECB@bba@@a@@aaaadfedegghfdccdbAEECA@
10134@BBCAACCDEDCEFFGHHEC@@AEFEEBA@a@cgiiiihgfeddddddb@@@@@bccdecaA
10072B@a@ABBBEDBAA@@ABDFDCDDCA@aaABCBA@@baa@BA@@aceggdba@@@@@cecbb@
10010BB@AA@@BBA@@BBAa@@accfggedb@@@AAACEFFCAA@b@BC@@DDA@@@@@@bbaaaa
9948@@bdc@@a@BCDEEFFD@a@@Aacb@DFGGDA@A@@AACCAcddbcedba@@aa@a@@A@@a
9886a@A@@@@@cb@A@@abb@BBB@@BEGHIHFECAABDDBA@dcbdcba@@@dhiheecabcba
9824@CDCBBA@@@@@@aaa@BA@a@ABCEDCA@A@@@@a@ADFEC@bca@A@cdccaaccddccb
9762@@a@BB@bbbaa@@bcccca@AA@@@ABCCDDCCA@bbabdb@@@AAAabbcb@@@@aa@AA
9700BAAAA@@@ABBBB@@@@@BBB@b@BAAAA@ACCCCCAabbdeedb@AAADAcffcabddcca
9638@@AA@bca@@@@A@aaabdfecbcdddeeda@bcaADDDCC@cdcb@@aa@bdedcabba@@
9576abbb@@@@adeddcba@bbbdggfdbdggfda@@@@@aa@ACC@bb@@@@@@AA@A@bdddc
9514@@@A@cfdaaa@@CEC@acdca@@@@A@ccbab@@@A@@ABCDDA@adeb@BCDB@A@@bfi
9452gecb@@bddb@@BAabba@aaaBDAaaba@@@@@ab@A@ceda@@aaaadfecACCA@ba@a
9390a@@bcddcbacfe@BCBABCCCBCDDDECABBBABC@bccbcefha1hddcbcdcdedbba@
9329@B@baaabdfggecaaa@DGGDBBBABC@@@@aa@A@@BC@aceeb@bdcaabb@ABCB@@A
9267@cfedffc@A@@BDDCCDEFFEEFEC@abbbaceeecbabbcbbbbcddcbaaa@aegffdd
9205edcdfgebABA@@AB@aab@CA@ACCBCBAACECBCCBAACFHGDBA@@aaa@BDFGFHHD@
9143aba@@@ADDCCCDCAA@abbaa@a@CB@ACFIHEDCBAA@@acba@@@@ADEEC@bba@@@@
9081CFGFAbcbabdfebb@@aca@@@ABBB@@@@bfec@ACEEEEDCA@ACEFFECA@ABDEDCC
9019@cedb@BEGFB@@aa@@@ABDCBA@ACCAA@@A@b@A@acca@@BDDBaegfdb@AA@bb@@
8957cdddcba@CCAAABB@@BCDGFC@ddaab@ACAACB@@bddb@A@@abb@AB@ba@BB@abf
8895feggedccee@EFC@@@@@bca@@@@@ab@@@aa@@b@AABCCA@cffda@BCDDEFDA@@@
8833@@@@ADGIHEC@bcaaaaa@@@a@@@@@@bcabbabc@BBCFEBA@@@AB@@@a@@@ACCB@
8771ADC@bca@@@BA@a@adcAC@acfecba@aaa@ACCCBA@bdceha0ihgededbAEFEAAC
8710DC@ABCBBBBCEFCA@@@aabdddbaabcca@@ABBCCBBCDCA@@BDDEED@bb@BCCDAA
8648@@@@@a@AEGEDDEFCaccefeddded@@a@bba@a@@A@accaABCDB@@@AAAAA@dfec
8586@@@abcbbbcddcdca@@@ADCCEFEFGGGD@b@@ceca@abca@bddb@@A@cdeea@@@@
8524@A@bdba@@aacecbaaa@BDEFEBAAAAA@@ab@DHFEDDEDCA@@@ABABAab@BBAABE
8462EB@BGHFDBaa@@@@CDA@A@aa@@beb@@@bbaacbcdeb@@baaabdc@@DFFDDB@a@@
8400aabbaaa@abaa@a@AAACCDCCDFFEFEEEDDB@@@@@@@beffeeccdffc@@@ACB@bc
8338bcb@BDCCBBBAA@BEGGFDAaa@a@@@AABDDDCB@@AACCCDDC@bbeeb@AACEFEB@b
8276b@@ABCCBAAaccccegfedbbdb@@A@bcedba@@ADFFD@abbbcda@@AA@ABCCCCAA
8214@@@BB@abeeb@BDFGFD@abba@@DDB@@@@@AA@aa@AA@@adcaa@EIHGGFECBCBB@
8152bbaba@BA@@aba@bddba@@@@abb@ACDCBBBC@ccdb@BB@@bedb@@@BDEB@@@ADF
8090D@@@@@@@@adeb@BDC@@@@@AABAba@aaBDCA@aabbaADEC@aca@@aaacefefc@@
8028aaaadccccb@acb@@adddffdc@@@@CDA@ABCBBCDC@bb@adgfdb@acddbcba@BD
7966A@BB@adca@BA@a@ADDB@@@acb@@BBBCBBBCCB@ccaaa@A@ababba@@a@BA@@@@
7904@@@B@abcaACDDDEDDAAAA@@@A@ACA@BCA@AAACFFGFC@bbdeb@@ccddb@@BBBB
7842DEECA@aaabcaaccdccegeccdddaa@@@@B@cddc@CEDCCBA@a@@@B@baabbaaac
7780dcaa@@@ACCAA@@ABCDCA@ABAab@@@aabbcb@CC@@@CDCA@AEFDCDDCAab@AABB
7718AA@@abcccaaba@A@@@@@@a@ADDFEEEDCABB@@A@@@BDDDEEDBACBCDEFGFEFFE
7656DEDDB@abbbcbbbacffedcaBDDCDDDCBCFGGEBAA@@AA@a@@a@@AA@cedaBCCB@
7594@BCCCAaAFGGGEB@b@AB@@BA@ADCBCCBA@@A@@@@@@bc@@a@A@@AB@@@@@@@a@a
7532a@bbba@@@BBCDC@ba@@a@AAADEEB@aa@ABAABA@ba@@@a@aa@@AABDDB@@AAaa
7470@abbbb@CCacbcb@aba@AA@adggdbbca@AA@a@@@BCAab@@beebbbbb@ACBA@BC
7408@dggfec@@@@aa@A@cd@BA@a@@ba@@a@@@bcddccbddca@ABDFHHHFDB@@@abdf
7346da@ba@@BDEEEBBAbca@@AA@c@BCEFFDB@@@@ABB@@cbb@bdcbcbabdb@@bdedc
7284bbbcbacfhgffgcaaabccbbadhihffebbcddddedaa@ACB@aegfddcb@@@abccc
7222bbdaAAA@bdfghgddb@@@@AAA@a@@@@@ABBBBBCCCCBA@CEDCC@egdaA@@@ACDA
7160bdddcb@AB@a@bddfgggfffggfeeeecbba@B@@AA@bdc@@@@@A@abcddcbBEDDD
7098B@ACDB@bdca@abaA@@@bb@abca@@BCAacdcdd@@BCBCECCEGFEDA@@@bca@aa@
7036a@@ba@@a@@@a@@aca@@A@a@DDB@@@A@aabaCDA@@AAbdcba@@@@@@AA@bbcbbc
6974baabcdca@@@BFGFEDCBAA@bcb@@dgfdddca@@@@acb@A@ceec@@add@B@@BCB@
6912a@@AA@@@@@@@@@BA@@@DECA@bffdbabba@@@adec@@@aa@aa@ababbaa@A@@@@
6850A@abbcceda@@aba@ABA@@bb@@@AA@AABA@acc@@A@a@A@a@@@bb@@@BBAaffd@
6788BBAA@abaccabbACCBBA@@@abcedbb@BA@bcb@A@abba@BDDDFEBbdeeeggfeda
6726@@BCB@@cecbcdcaaa@@@CFFDAaba@@baCFGEEEDDEDBBCBBA@@@@a@DEB@@@bd
6664c@CEGGDCBB@bdfhgea@bdc@@@@behheaAAAAACBA@A@BA@aaACAAB@cdefebab
6602cb@@baAA@@cefc@AABCDDCA@a@aaa@bddbAB@a@@a@B@ababbbbbbaACAaaBCB
6540BB@cba@@A@@ABA@BAafhigcabdfhgc@@aaa@@@@AA@aaba@@b@@a@accbcca@@
6478@AABA@@@BAdfc@aabbaAA@bccffebabcbaaacdccbbcccdcaabc@CDCCCABBA@
6416aceeecdffffcAC@abaabaa@ACDDC@BBBA@abehgfecbbaaab@AA@@Aab@ABBAc
6354eedb@@A@cddcb@CEDDCA@AB@@ADDDDDCACFIA0HGEEDDCBBAbccbaabceeddda
6293@bdca@@ABDB@@@acb@ACDCA@cdddcaabbaabccbbddccdca@bdb@a@@@acdca@
6231@ab@AB@bb@@bdffeecaacbAA@@ceebabb@A@bbaa@@@aba@@@ABAAA@@CDCAA@
6169aacfeaBCEEDBA@@A@@@@@aaabdccccb@@a@@@@a@@@@CDDFGFB@@abbbbaAA@@
6107@AB@AA@@@AAAAaffecabddb@A@bdfebbc@BCABEDCAABA@AA@bdcccbcddcbcd
6045dcaa@ACB@adfecdfghheefgfdccdedbbbcefddfecb@@bceb@@CEECCCA@@aaa
5983AA@@ABA@AAA@BFEBACDDECAadbcedcfiifb@aa@@@@@bdeddffddffedcbaa@b
5921edcba@@ABA@ABBA@ABBCEEBCB@cc@@@@@@bcccefdbbbcaA@baAC@deedbbabd
5859ddb@ABBbfgdbaaa@ABCDC@@@aa@BB@@abcfa0a2a2ifddcb@@@@beecbcdfeee
5800ffecaba@@@acecaAAabba@BCC@ceffecdc@BAAA@cffc@BDDDAacegghfddehg
5738ffedecceebba@@@@AA@adfdbcdcdeedba@@ab@abccaabba@@ADDCBAaaAB@ac
5676cdcb@AA@ACDBcfeccdeddefefe@BDFGGD@abccdddcccfgeccc@@@@AAABB@a@
5614@@AAafgdaaa@@ACDCAACDDAaABA@ABBAAB@bcba@@CCAbc@@@@aa@A@@bcb@bd
5552dc@@@@A@bb@@aa@@ACB@aa@@@a@@AA@bbabbbbbba@@aa@BBAaaaa@ABBA@aba
5490bcbabbb@ABCB@cca@ABA@BEECCB@@AAA@@aba@AA@AA@@@b@@bcaACAbcdca@D
5428FEB@@B@cdcbbbba@cgea@abbbcba@AA@@@a@ABA@@aabddaADDBAab@CDCDCBB
5366A@@@DDAbdccdeeb@AA@@@@A@@AA@@@@BEEAabaabaACCAA@@@@AAACBA@accca
5304bdbABAABBCECDEDB@@@@@@AADDB@@@bcddedcaBBA@cefeffdbbbccaA@fa0a0
5244iia1a1hghfc@A@a@@ADFC@bbcedaABCAacccccccdggggfffeca@@CAaa@cedc
5184c@@@ACDEEFHHFC@@addcca@@@@aa@ceeec@BEEDGGBadeda@aaaba@bcbbbacd
5122cdedcbbcccdgfdbccbabbcaA@bcccb@BAacdddc@BA@AAA@AA@AA@cca@@@c@A
5060@cb@@@BCBCA@cec@@bbdddfeggfdb@@a@ABC@cb@DEFFDA@a@@@@@@@@bbbcb@
4998BDBA@@BB@BCDBaa@@@AAA@beffecaabcb@a@A@bbabdecba@B@@@@@A@@@bddd
4936aABDCBCCAadc@ABDDA@ba@aaaaa@@A@AEFEECA@A@ceb@CEECBA@ACCCDEDCDH
4874HGEBA@bbaabcfeb@Aaefeb@@@bedaadhihedcda@@B@@@@@AAa@@@@aaa@@abb
4812@A@ADB@A@acb@BB@baadc@@aabcdeeecbbaa@abbaabcddcbaaa@A@aaa@AA@A
4750@AABCA@aba@BDCA@bbbcacda@ADFECBA@aaba@A@BAA@@@@@@BBB@@aaba@@@@
4688DGHGEB@@AACA@AA@@aaa@AA@@@CDDAabcdb@BDDBBAbaBCEFC@ABCCAadffedb
4626ba@AA@@@@@@ba@a@@deccdc@CEGHEA@@aaaab@ABBA@@ACCAABA@bcbaaa@aaa
4564aa@ADBacddb@BA@a@@AAB@bb@ED@ccbbbabdcbabcedc@C@cdc@@bbbcedceff
4502gdaABBA@cb@@A@@cccccbbdec@@@@BEHHFDCB@a@CGFDC@@a@AAA@a@@bdb@@A
4440@@@@acccdedceeccddcaA@bc@A@abca@@@@@@@@aabcbADC@aaaaa@@@@AACDB
4378AABAbedbb@CDDDDDC@acfcbdca@@@@@@@A@@@AaaADFGGECCB@@a@AA@@@ceed
4316ccb@ABCBACB@bb@@AAAAB@aa@@aa@AA@aaAA@@@@@@aabcca@ACCBA@bddcb@b
4254cca@@@B@aaaa@@A@a@@aaaa@@@BB@@ABA@acddb@@ABA@A@a@@bceeffeefeba
4192@@aabbba@AEDCDC@@@AAACBABA@@a@ABCB@@AAA@@@@@AC@bb@@@BCCDDDDDBA
4130@@ABB@ca@@@BCB@@@@ABBCDCAAA@@acaac@CECABBBA@@bdcaa@@@@BBA@abac
4068ca@@a@DGGDCCBCEFEEDA@@@@@BEECBA@abcb@BB@bbccca@A@abbcdccbba@aa
4006@@a@BDCBBCDCCDDBCA@a@@aacb@ACDEDCA@@CCBBB@@a@@@ACDDCA@@aaa@@ac
3944ca@@@BBA@@@@@@@AABA@@AAaceeeebA@ADDC@@@@@ABBBBDAbb@@AA@cdefgea
3882aaa@abbb@DCCDC@abb@ABBACC@babdgeaabbaaaaa@@@abcdbaaa@@@AA@BCCC
3820DDDCB@abcddehhebbaBDGFD@cfecaaa@@BEFDCC@ba@@BCBB@ceedca@@BCCB@
3758behigdddccca@@ACEEDCA@BECA@bcccbBGGFEDCA@@@@ACCDEEB@dffeeddddd
3696bACBBBCCA@aa@aba@@@aegdbaabcb@A@aaa@@@@acbcdffdcdghfc@acb@aaba
3634beeb@@AAacdddefdaadfa0ifc@CCEGGC@@abaACCCCDBAAAAA@@accdcaa@AA@
3573@@abbbcdca@AA@bcddcbbcccbbdca@A@@ab@CCCA@@AA@aa@@@bdfgggecbaab
3511aaa@@A@a@A@ccddccda@a@a@AabbcdeddffedbbccbAA@@AACCCDEFFFEDCBA@
3449@bccdcbab@@b@@@@baAACB@@baAAAAA@AEC@@cgfffecdb@@@@@A@@@@Aaccbc
3387caabbbba@@ABA@@abcddaBAAA@@acccbbaaacfebbcdcb@@BA@BDCBA@@AABBB
3325B@aa@@ABCAA@@@@@@aabcdffdccdeecdddfd@@@@@ABCCA@@a@@aBBAAbdedb@
3263B@aba@@adfeaa@CDEEDBCED@@@@@bc@@aa@abb@BDCAAB@@aaAEHGC@ABDDDB@
3201a@BA@@@@@abb@A@a@@ACAABA@@AADGGEDEEEDCCDAbaa@@BCAaba@AA@@@A@ce
3139ffefeba@@A@aefbBDB@baa@bca@@AACCA@cdeb@@@abceffeb@@dffeaA@@A@@
3077BDAadfeca@@CCCAbcddege@AA@bccbab@accdcbcccba@abbabc@CDCbcbbcdc
3015cca@BEGGFCA@@@BCAabcb@@bdeegfedefffa@AAABDEEC@abb@@ABA@aa@@@BC
2953B@cdaA@ba@@@bdedbBEDCCBadb@@@a@@@BC@a@BA@@@ABDEB@adcabddddda@A
2891AA@acdba@adgihgdcdfeb@@aaba@@abaACBA@@BECBDDBABBA@@bcaaaacefdc
2829cddcaba@@@abdfeb@@@@ab@A@ABDDCCCCBDFGGC@ABBBBCA@cedcba@AB@aaab
2767caadghfedbbcabcca@@@@ABCDCAACDDB@AAAAB@abbbcccabbcedca@AA@@@@A
2705CC@cbBFGGFCBDC@@CDFFEEDAabADB@abegfbBDBABFGGFECCBAACED@bbcccbb
2643@@@ab@A@bbbbbcdcaa@@@@BCCBA@@@BCB@@BA@@@@@A@aa@bccbcddefeb@AAB
2581BBB@ab@@@@BCCA@abcddc@@AaccccaBEC@bbbbcbaaaccddcdcbaaaabddb@AC
2519@bdfeaab@@bbdia0hhgcaaa@A@ACB@abbcdcbcdecaA@bca@@abaaa@CEDDGIG
2458FGGGC@@@@aa@CCACDA@@cdbccccdded@AB@cb@@@bddcbabaACEFGE@deec@AA
2396@becccbcb@adfedeb@BCCA@@@@@@@@AAaa@AAABAAABDBB@@@bccdccca@ABA@
2334@bccbcdbabeffdbbbddcb@ABBAADDAABB@@@@@aa@@@@AAABAabbaabcbdehig
2272dbabcdb@A@@@A@@@A@@@@@@AAABBB@@@@AABBBCCBBBAab@@BCAbcdfgggfgec
2210ddc@BCA@ABCDBA@cdb@A@aa@@@bded@@@abb@AABC@@@bb@EGFFIA0IGDAab@B
2149A@@@@@A@ACCAAA@abbaa@BBA@bded@BCCCCA@ADCA@@aaAB@ABCCDDCDDEDCFG
2087ECCBA@CFFDDCA@ACCBABDEGGCCB@@@bcbbeggd@@@ABAAAABAbca@@ABCCA@AB
2025CDB@@acca@@@a@@abb@@ab@@@abb@ADFDA@@@@@aa@@@bbbbaa@AADDAbdceda
1963@@BBABDDCBBA@@ABAACBABBDDA@@ACC@cecbcec@@a@aba@ABAbdcaabb@ACCB
1901AADDBAA@accccdfggefeccddeed@CB@@aaceeffda@ABDEC@@@ACCA@baaaa@A
1839ABCDDCCB@@BAAAA@@@aca@aa@A@BB@@@@cdca@AAA@@bb@@A@a@@B@beeb@DCA
1777AA@@@aca@@@@@aaabddbADDCDFFCBA@@A@@@A@ba@@@A@b@@@baBFGHFC@abba
1715cc@@bcdcbba@@aca@@@acbbcddccb@bcfhggfcceeeeb@BB@@aa@A@ba@@@ade
1653b@@abdedcc@CA@bbbaaa@@BBA@abcb@CDDDCAA@@@@abbaaa@abbccb@@accb@
1591@@cdbaa@acca@@AABCBB@@aa@@@@bbbdecbabbacccbaBBA@abcda@@A@a@@@a
1529ccaaa@A@AABCDDCB@@BDEEEDDDBBCCCB@@CB@@BBA@acdcffdbacdeffehhgd@
1467BDDCBA@ba@@@CFFCCB@@@@@abadfdccdeefhhfeefhfccefedcba@ADGFDB@ad
1405ecaba@BCCDBAABB@cdbcddebaba@@@AA@AADGFCACDAabdeda@@BBBCBA@@@@@
1343@ba@@@@@AA@@@@cdca@@A@@ABA@@adeghgfda@@@@BBCDDAccaa@@@@@A@@A@@
1281@BA@bbdfgb@@cdcbbccced@B@@@aaACA@dfededc@@ABEA0A1GCB@aba@@CEEC
1221B@@@BBB@@@AAABCDB@aa@@@ACCA@A@@@@A@a@@acbabcb@@@ceec@BAAA@bbcb
1159aaba@AA@@@cffcbaBB@a@BCDDB@bba@@@@@AA@a@ABDHIIGDB@@ceeeaADCCDC
1097BCC@@abcca@@@BCCDCBAACA@CEEEDB@@@BDDCA@@b@@B@cfgefgfdcccacda@a
1035cdcba@@ABBC@a@BDBacdfihgeba@@@@@@bca@@AA@@Aacefa0a1hfedb@CC@bb
975cdecabeghdaacdda@@@@@@@@aa@@@AACAbaACEEB@@@@@abcb@CCAACCABCCCA
913@ABBAB@@@a@CCA@@ABB@bcba@@ABBAaacdcdb@CDDDAaddegiigggfda@A@bce
851ecaa@AA@@@ADEFGD@a@BEED@cccdddgfcb@ABB@@@@@@cddcaACBDFEBABBDDD
789CEFEEDED@aaaaaba@@a@AACCBA@@AAAA@abcbcedaaca@AAaa@@@abaabefeb@
727AEDB@bcb@AA@@@aabb@BCA@@@ceddcccacffc@@@accaadfcaab@@BCBCB@@AA
665@@abccdedddb@AAA@@abbbbcd@@@aa@@@@ACDDCCDCBBCCBBCBBA@@@ABABCED
603BAA@@bb@@bdccdfgfga0a0geeffdca@@@@@@@@@@@@@@@AB@@@@bcaaa@ABCDC
543Aa@CDDDDCDB@@bbbcdbba@addefgggfecceffc@AACEC@abccbcb@@BBA@@@@@
481@@@@@AB@@@@CCBCCCDCCB@aa@@BCBABBBCCBCDDDB@cdb@@ABBA@@@@@AA@aa@
419@bcdfecbca@@@aa@@@aaa@AAacbbbbcccca@@A@@befdca@ABAabbbdeeecbb@
357@BBBA@@@BBA@@@@ACDDDCBABCDCDEB@@@ABB@cdcbcba@@@a@AA@@@bbacdaAA
295AABBAABBBDDDCA@abb@a@ABAAAB@abb@@ACCCB@@aa@@bbdddbacdca@@@@@aa
233@AAA@bbbceedccb@ABBCBA@@@@a@@@@aabdddcbbacddcbb@@@@@@@@@@@@@@a
171@@aa@abb@@AAA@b@A@@@abcb@@A@@@@@BB@@@a@ABA@ABCBAA@@@@aaa@@@@@b
109@ABCDDAacdedba@BBAaccbba@@AABBBBBAAAABCCAab@ACA@@A@@@@@@@BCCA@
47@@@@BBAABAAB@@abddccbaaa@@ABBCAA@@@@ACCCCCBAAA@
$$ === CHEMSPECTRA ===
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
(1, -12.130463794451742, -9.398614014574463, -10.727, 1.1, 1, m, A)
(2, 102.60725261722573, 106.81010163952563, 105.112, 2.2, 2, m, B)
##$OBSERVEDMULTIPLETSPEAKS=
(1, -11.045182110091531, 483.3954030761719)
(1, -10.727346827203405, 494.5395485961914)
(1, -10.409511544315308, 477.8595126068115)
(2, 104.69281295027619, 641.2949194702148)
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
10.123456
11.123456
12.123456
13.123456
14.123456
15.123456
16.123456
17.123456
18.123456
19.123456
20.123456
21.123456
28.550000190734863
28.59999942779541
33.29999923706055
107.20000076293945
143.5500030517578
147.8000030517578
151.35000610351562
154.8499984741211
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=SVS-701A3.11.fid
##JCAMP-DX=5.00
##DATA TYPE=NMRPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.005
##MAXX=147.58525877714158
##MAXY=2894.0
##MINX=-103.37058777795372
##MINY=-14.0
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=10
##PEAKTABLE= (XY..XY)
-11.045182110091531, 483.3954030761719
-10.727346827203405, 494.5395485961914
-10.409511544315308, 477.8595126068115
33.723640688041044, 2666.6348208618165
36.741161205099345, 1727.668196218872
40.95726537931404, 1807.703423135376
43.476971597872875, 1750.2097632934572
46.819986079334626, 1696.6961554229736
63.07170825496331, 2894.583251953125
104.69281295027619, 641.2949194702148
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=SVS-701A3.11.fid
##JCAMP-DX=5.00
##DATA TYPE=NMRPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.005
##MAXX=147.58525877714158
##MAXY=2894.0
##MINX=-103.37058777795372
##MINY=-14.0
##NPOINTS=34
##PEAKTABLE= (XY..XY)
104.69281295027619, 641.0
63.32827408572841, 23.0
63.07170825496331, 2894.0
58.610526272256564, 250.0
58.545427479375874, 18.0
54.0, 650.0
47.09952795464588, 16.0
46.92720762054991, 18.0
46.81998607933464, 1696.0
46.71659387887706, 16.0
43.561217094542, 20.0
43.47697159787286, 1750.0
41.20617252856377, 26.0
40.95726537931404, 1807.0
40.6432594371836, 17.0
36.741161205099345, 1727.0
33.976377178048466, 24.0
33.723640688041044, 2666.0
33.62790716909885, 32.0
33.42495210894137, 29.0
22.10542082921509, 19.0
-10.409511544315308, 477.0
-10.482269018711378, 19.0
-10.509074404015195, 20.0
-10.528221107803631, 20.0
-10.612466604472758, 15.0
-10.727346827203405, 494.0
-10.7962749608418, 29.0
-10.857544412964813, 15.0
-10.945619250391644, 25.0
-11.045182110091531, 483.0
-11.129427606760686, 18.0
-58.23031892632537, 22.0
-58.272441674659945, 15.0
##END=

##END=


`;

export default nmr13CJcamp;
